import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler,
    Text,
    TouchableWithoutFeedback,
    Image
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import AdapterListOperatorApply from "./adapters/AdapterListOperatorApply";
import store from "../../../../redux/store";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError,
    serviceActionSetLike,
    serviceActionSetDisplayImage,
    serviceActionSetDisplayComment,
    serviceActionSetComment, serviceActionAddFile, serviceActionAddComment
} from "./action/ActionGalleryServiceOperationScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
import HMTextInput from "../../../../customviews/HMTextInput";
import * as NavigationService from "../../../../redux/NavigationService";
import HMButton from "../../../../customviews/HMButton";
import HMIcon from "../../../../customviews/HMIcon";
import HMModalSearch from "../../../../customviews/HMModalSearch";
import HMSwiper from "../../../../customviews/swiper/HMSwiper";
import HMImageView from "../../../../customviews/HMImageView";
import HMModal from "../../../../customviews/modal/HMModal";
import ImagePicker from "react-native-image-crop-picker";
import {Tools} from "../../../../tools/Tools";
import axios from "axios";
import HMAlert from "../../../../customviews/HMAlert";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import Toast from "../../../../customviews/toast";
import importFirebase from "../../../../importCalss/firebase/importFirebase";
import HMRecycleView from "../../../../customviews/HMRecycleView";
import {serviceActionSetToken} from "../../splash/action/ActionSplashGetAllData";
import {isMobile} from "react-device-detect";

let container = null;
let backClickCount_value = 0;


/*
*
* const some_array = [...this.state.some_array]
some_array[indexHere] = yourValue
this.setState({some_array:some_array})
* */

//import {RecyclerListView, DataProvider, LayoutProvider} from 'recyclerlistview/web';
//import {RecyclerListView, DataProvider, LayoutProvider} from 'recyclerlistview';

let firebase = importFirebase;

let valueComment = null;
let recyclerlistview = Platform.select({
    web: () => require('recyclerlistview/web'),
    android: () => require('recyclerlistview'),
    ios: () => require('recyclerlistview')
})();

const {RecyclerListView, DataProvider, LayoutProvider} = recyclerlistview;
export default class GalleryServiceOperationScreen extends Component {
    constructor(props) {
        super(props);
        // global._refreshListOpertor = true;


        container = this;
        let viewportWidth = Platform.OS === "web" ? 1 : typeExport._WIDTH;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 1000 ? 2 : 1;

        }

        if (Platform.OS === "android") {

            //firebase = require("react-native-firebase")
            // alert(firebase)

        }
        this.state = {
            canChangeSize: false,
            dataProvider: new DataProvider((r1, r2) => {
                return r1 !== r2;
            }),
            layoutProvider: new LayoutProvider(
                () => {
                    return 'VSEL'; //Since we have just one view type
                },
                (type, dim, index) => {
                    let columnWidth = viewportWidth;
                    switch (type) {
                        case 'VSEL':
                            dim.width = columnWidth;
                            dim.height = 1;
                            //dim.width = 0;
                            // if (index % 3 === 0) {
                            //     dim.width = 3 * columnWidth;
                            //     dim.height = 300;
                            // } else if (index % 2 === 0) {
                            //     dim.width = 2 * columnWidth;
                            //     dim.height = 250;
                            // } else {
                            //     dim.width = columnWidth;
                            //     dim.height = 250;
                            // }
                            break;
                        default:
                            dim.width = 0;
                            dim.height = 0;
                    }
                }
            ),


            lllll: true,
            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            //  textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,


            /* dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                 name: 'در دست اقدام',
                 id: 2
             }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                 name: 'تایید واحد',
                 id: 5
             },],
             textCondition: null,
             arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                 name: 'تکراری در دست اقدام',
                 id: 3
             }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],*/
            Condition: {id: 0, value: "وضعیت پیام"},

            // arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            //   dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null,
            showModal: false,

            list: [
                {
                    id: 1,
                    like: false,
                    files: [
                        {
                            id: 1,
                            image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
                            display: false
                        },
                        {
                            id: 2,
                            image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
                            display: true
                        },
                        {
                            id: 3,
                            image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
                            display: true
                        },
                    ],
                    lastWork: [
                        {
                            id: 10,
                            title: "شهروند",
                            comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
                            display: false
                        },
                        {
                            id: 11,
                            title: "137 منطقه",
                            comment: "بازرسی شد و گفته شهروند صحیح است",
                            display: true
                        },
                        {
                            id: 12,
                            title: "مجری",
                            comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
                            display: false
                        },
                        {
                            id: 13,
                            title: "رضایت مندی",
                            comment: "شهروند از عملیات رضایت ندارد",
                            display: true
                        },
                        {
                            id: 14,
                            title: "بازرسی",
                            comment: "عملیات مجری مورد تایید است",
                            display: true
                        },
                    ]
                },
                {
                    id: 2,
                    like: true,
                    files: [
                        {
                            id: 1,
                            image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
                            display: true
                        },
                        {
                            id: 2,
                            image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
                            display: true
                        },
                        {
                            id: 3,
                            image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
                            display: true
                        },
                    ],
                    lastWork: [
                        {
                            id: 10,
                            title: "شهروند",
                            comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
                            display: true
                        },
                        {
                            id: 11,
                            title: "137 منطقه",
                            comment: "بازرسی شد و گفته شهروند صحیح است",
                            display: true
                        },
                        {
                            id: 12,
                            title: "مجری",
                            comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
                            display: true
                        },
                        {
                            id: 13,
                            title: "رضایت مندی",
                            comment: "شهروند از عملیات رضایت ندارد",
                            display: true
                        },
                        {
                            id: 14,
                            title: "بازرسی",
                            comment: "عملیات مجری مورد تایید است",
                            display: true
                        },
                    ]
                },
            ]

        };
        container = this;


        this.props.navigation.addListener('focus', () => {


                this.setState({
                    loadData: true,
                    canChangeSize: true
                })
            }
        )
        this.props.navigation.addListener('blur', () => this.setState({
                canChangeSize: false,
                loadData: false,
            })
        )

    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {


        props.results && props.results.length > 0 && this.state.Once ?
            this.setState({
                    Once: false
                },
                () => {
                    if (firebase)
                        this.goDetailsOpenNotif()

                }
            )
            :
            null
    }

    /*    async componentDidMount() {

            const channel = new firebase.notifications.Android.Channel(
                'channelId',
                'Channel Name',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }

                if (notification && notification.data && notification.data.typeOperation === '1') {
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });
        }*/

    async componentDidMount() {
        if (!this.props.token && (this.props.route && this.props.route.params && this.props.route.params.token)) {
            // let token = await AsyngStorageClass.checkToken();
            let token = this.props.route.params.token;
            // alert(token)

            store.dispatch(serviceActionSetToken(token));
        }


        this.setState({
            layoutProvider: new LayoutProvider(
                () => {
                    return 'VSEL'; //Since we have just one view type
                },
                (type, dim, index) => {
                    const columnWidth = this.state.viewportWidth;
                    switch (type) {
                        case 'VSEL':
                            dim.width = columnWidth;
                            dim.height = 550;
                            //dim.width = 0;
                            // if (index % 3 === 0) {
                            //     dim.width = 3 * columnWidth;
                            //     dim.height = 300;
                            // } else if (index % 2 === 0) {
                            //     dim.width = 2 * columnWidth;
                            //     dim.height = 250;
                            // } else {
                            //     dim.width = columnWidth;
                            //     dim.height = 250;
                            // }
                            break;
                        default:
                            dim.width = 0;
                            dim.height = 0;
                    }
                }
            ),
        })

        if (Platform.OS === "web") {
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 1000 ? 2 : 1,
                    },
                )


            })
        }


        store.dispatch(serviceActionListFilter([]))
        this.props.callserviceActionRefresh();
        this.getData(1)

        // store.dispatch(serviceActionSuccess([
        //     {
        //         id: 1,
        //         like: false,
        //         files: [
        //             {
        //                 id: 1,
        //                 image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
        //                 display: false
        //             },
        //             {
        //                 id: 2,
        //                 image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
        //                 display: true
        //             },
        //             {
        //                 id: 3,
        //                 image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
        //                 display: true
        //             },
        //         ],
        //         lastWork: [
        //             {
        //                 id: 10,
        //                 title: "شهروند",
        //                 comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
        //                 display: false
        //             },
        //             {
        //                 id: 11,
        //                 title: "137 منطقه",
        //                 comment: "بازرسی شد و گفته شهروند صحیح است",
        //                 display: true
        //             },
        //             {
        //                 id: 12,
        //                 title: "مجری",
        //                 comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
        //                 display: false
        //             },
        //             {
        //                 id: 13,
        //                 title: "رضایت مندی",
        //                 comment: "شهروند از عملیات رضایت ندارد",
        //                 display: true
        //             },
        //             {
        //                 id: 14,
        //                 title: "بازرسی",
        //                 comment: "عملیات مجری مورد تایید است",
        //                 display: true
        //             },
        //         ]
        //     },
        //     {
        //         id: 2,
        //         like: true,
        //         files: [
        //             {
        //                 id: 1,
        //                 image: "https://media.tahlilbazaar.com/d/2020/09/30/3/43418.jpg",
        //                 display: true
        //             },
        //             {
        //                 id: 2,
        //                 image: "http://media.sarpoosh.com/images/9709/97-09-c07-634.jpg",
        //                 display: true
        //             },
        //             {
        //                 id: 3,
        //                 image: "https://media.mehrnews.com/d/2016/08/10/3/2168553.jpg?ts=1486462047399",
        //                 display: true
        //             },
        //         ],
        //         lastWork: [
        //             {
        //                 id: 10,
        //                 title: "شهروند",
        //                 comment: "رسیدگی به این کوچه افتضاح است رسیدگی شود",
        //                 display: true
        //             },
        //             {
        //                 id: 11,
        //                 title: "137 منطقه",
        //                 comment: "بازرسی شد و گفته شهروند صحیح است",
        //                 display: true
        //             },
        //             {
        //                 id: 12,
        //                 title: "مجری",
        //                 comment: "نظافت کامل انجام شد و تذکرات لازم و مس",
        //                 display: true
        //             },
        //             {
        //                 id: 13,
        //                 title: "رضایت مندی",
        //                 comment: "شهروند از عملیات رضایت ندارد",
        //                 display: true
        //             },
        //             {
        //                 id: 14,
        //                 title: "بازرسی",
        //                 comment: "عملیات مجری مورد تایید است",
        //                 display: true
        //             },
        //         ]
        //     },
        // ]))

        if (firebase) {
            const channel = new firebase.notifications.Android.Channel(
                '1',
                'A',
                firebase.notifications.Android.Importance.Max
            ).setDescription('A natural description of the channel');
            firebase.notifications().android.createChannel(channel);

            // the listener returns a function you can use to unsubscribe
            this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                //  alert("yyyy")
                if (Platform.OS === 'android') {
                    const localNotification = new firebase.notifications.Notification({
                        sound: 'default',
                        show_in_foreground: true,
                    }).setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .android.setChannelId('channelId') // e.g. the id you chose above
                        .android.setSmallIcon('logo') // create this icon in Android Studio
                        .android.setLargeIcon('logo') // create this icon in Android Studio

                        //  .android.setColor('#000000') // you can set a color here
                        .android.setPriority(firebase.notifications.Android.Priority.High);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error("error_notifications", err));

                }
                else if (Platform.OS === 'ios') {

                    const localNotification = new firebase.notifications.Notification()
                        .setNotificationId(notification.notificationId)
                        .setTitle(notification.title)
                        .setSubtitle(notification.subtitle)
                        .setBody(notification.body)
                        .setData(notification.data)
                        .ios.setBadge(notification.ios.badge);

                    firebase.notifications()
                        .displayNotification(localNotification)
                        .catch(err => console.error(err));
                }


                if (notification && notification.data && notification.data.typeOperation === '1') {
                    if (item.length > 0) {
                        global.list_menu_shahrdar = item;
                        this.setState({alaki: !this.state.alaki})

                    }
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            });


            this.notificationOpenedListener = await firebase.notifications().onNotificationOpened((notificationOpen: NotificationOpen) => {
                // Get the action triggered by the notification being opened
                const action = notificationOpen.action;
                // Get information about the notification that was opened
                const notification: Notification = notificationOpen.notification;
                let item = null
                if (notificationOpen.notification.data.item)
                    item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                try {
                    firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)

                    switch (notificationOpen.notification.data.typeOperation) {
                        //looking for
                        case "1":
                            if (item) {
                                // if (this.props.result && this.props.result > 0) {
                                //     let idx = this.props.result.CartList.findIndex(obj => obj.RequestID === item.RequestID)
                                //     if (idx === -1) {
                                //         store.dispatch(serviceActionListFilter([]))
                                //         this.props.callserviceActionRefresh();
                                //         this.getData(1)
                                //     }
                                //
                                // }
                                //  NavigationService.navigateParams("DetailsOperatorApplyScreen", {item: item})

                                NavigationService.navigateParams("DetailsOperatorApplyScreen", {
                                    index: 0,
                                    item: item,
                                })
                            }

                            // NavigationService.navigatereset("MessagesBuy", {type: 1});
                            //NavigationService.navigateParams("MessagesBuy", {type: 2});
                            break;

                        // case "1":
                        //     // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //     NavigationService.navigateParams("MessagesSell", {type: 1});
                        //     break;
                        default:

                    }

                }
                catch (e) {

                }

            });

        }


        // let myLocation = store.getState().reducerSplashGetAllData.Location;
        // myLocation ? this.sendLocation(myLocation.coords) : null;

    }

    async goDetailsOpenNotif() {
        const notificationOpen = await firebase.notifications().getInitialNotification();
        let item = null

        if (notificationOpen) {
            if (notificationOpen.notification.data.item)
                item = JSON.parse(notificationOpen.notification.data.item.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())
            firebase.notifications().removeDeliveredNotification(notificationOpen.notification._notificationId)
            try {
                switch (notificationOpen.notification.data.typeOperation) {
                    //looking for
                    case "2":
                        if (item)
                            NavigationService.navigateParams("DetailsOperatorFireApplyScreen", {
                                index: 0,
                                item: item,
                            })
                        // NavigationService.navigatereset("MessagesBuy", {type: 1});
                        //     NavigationService.navigateParams("MessagesBuy", {type: 2});
                        break;

                    case "1":
                        // NavigationService.navigatereset("MessagesSell", {type: 2});
                        //NavigationService.navigateParams("MessagesSell", {type: 1});
                        break;
                    default:

                }

            }
            catch (e) {

            }
        }
    }

    componentWillUnmount() {
        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
            this.notificationOpenedListener();

        }
    }

    async getData(page) {
        //  let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlGalleryServiceOperationScreen, `?type=${this.props.typee}&Condition=`, TypeGetGalleryServiceOperationScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlGalleryServiceOperationScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetGalleryServiceOperationScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetGalleryServiceOperationScreen, _GET, page, 10)
  */
        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": "GetTicketsAlbum",
            "lang": i18n.locale,
            //   "_session": store.getState().reducerSplashGetAllData.token,
            "_session": (this.props.route && this.props.route.params && this.props.route.params.token) ? this.props.route.params.token : store.getState().reducerSplashGetAllData.token,
            "page": page,
            // "type": data.type,
            "listFilter": this.state.arraySelected,
            "trackingCode": this.state.trackingCode,

            //"token_fb": this.props.DataSplashScreen.token_fb,
        };
        if (store.getState().reducerSplashGetAllData.Connection) {

            this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetGalleryServiceOperationScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApply + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };


    render() {
        let {item, data} = this.props.route && this.props.route.params ? this.props.route.params : {}
        let {TypeLogin, resultsShahrdar, results} = store.getState().reducerSplashGetAllData;
        // let checkClick = (TypeLogin === 2 ? resultsShahrdar : results)
        let checkClick = (TypeLogin === 2 ? resultsShahrdar : results)
        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        let heightSlider = (this.state.viewportWidth > 600) ? 500 : (Platform.OS === "web" ? this.state.viewportWidth : typeExport.WIDTH) / 1.6;
        let widthSlider = this.state.viewportWidth - moderateScale(Platform.OS === "web" && !(isMobile) ? 30 : 4);
        return (
            <View style={{position: 'relative', flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        {
                            this.props.route && this.props.route.params && this.props.route.params.header ?

                                null
                                : <HMActionBar
                                    // menu
                                    props={this.props} statusBarTransparent
                                    // text={i18n.t('ListOperatorApply.title')}
                                    //text={i18n.t('ListNews.title')}
                                    text={data ? (data.name ? data.name : (data.title ? data.title : '')) : ""}
                                    //  text={this.state.arraySelected.length}

                                    back
                                    //  text={i18n.t('constant.Information')}

                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}

                                />
                        }
                        {/*<TouchableOpacity
                            onPress={()=>{
                                store.dispatch(serviceActionAddSubList([{
                                    address:"aaaa",
                                    code: "_",
                                    color: "#ff0000",
                                    comment: [],
                                    createdtime: "19/8/8",
                                    image:null,
                                    video: null,
                                    latitude: '43.56564',
                                    longitude: "34.37546",
                                    status: i18n.t('constant.registrated'),
                                    title: "aaabbbb",
                                    subjectid: "111"
                                }, ...store.getState().reducerGalleryServiceOperationScreen.results]))
                            }}
                            style={{width:'100%',height:moderateScale(40)}}
                        />*/}
                        <View style={{flex: 1}}>
                            <View
                                style={{
                                    height: moderateScale(42),
                                    backgroundColor: Colors.colorPrimary,
                                    flexDirection: 'row',
                                    marginHorizontal: moderateScale(10),
                                    marginTop: moderateScale(6),
                                    borderRadius: moderateScale(14),
                                    borderColor: Colors.colorDark,
                                    borderWidth: moderateScale(1),
                                    //  marginBottom: moderateScale(10)
                                    // width:'100%'
                                }}>

                                <View
                                    style={{
                                        flex: .8,
                                        height: moderateScale(40),
                                        backgroundColor: Colors.white,
                                        borderRadius: moderateScale(14),
                                        flexDirection: 'row',
                                        paddingHorizontal: moderateScale(4),
                                        alignItems: 'center',

                                    }}>

                                    <View style={{width: moderateScale(5)}}/>

                                    <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                        <HMTextInput value={this.state.trackingCode}
                                                     onChangeText={(text) => this.setState({trackingCode: text}, () => {
                                                         //  this.getJsonMap()

                                                     })}
                                                     _height={40}
                                            //  autoFocus
                                            //  placeholder={i18n.t('constant.filter')}
                                                     placeholder={"جستجو آدرس و کد پیگیری"}
                                                     NoShowPlaceholder
                                            //باتد_width={'80%'}
                                            // icon={"md-person"}
                                                     style={{
                                                         fontSize: moderateScale(13),

                                                         // marginTop: moderateScale(6)
                                                     }} underlineColorAndroid="transparent"/>
                                    </View>
                                    {
                                        this.state.loadingAddressMarker ?
                                            <ActivityIndicator color={Colors.colorPrimary}
                                                               size={"large"}/>

                                            :
                                            <HMTextView
                                                numberOfLines={1}
                                                onPress={() => HMAlert(
                                                    i18n.t('constant.address'),
                                                    this.state.addressMap,
                                                    [
                                                        // {text: 'Ask me later', onPress: () => {}},
                                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                                        {
                                                            text: i18n.t('constant.ok'), onPress: () => {
                                                            }
                                                        },
                                                    ],
                                                    {cancelable: true}
                                                )}
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={this.state.addressMap}
                                                type={"bold"} style={{
                                                //textAlign: "center",
                                                color: Colors.gray,
                                                fontSize: moderateScale(13),
                                                marginEnd: moderateScale(3)


                                                // flex:1
                                            }}/>
                                    }

                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.getData(1)
                                        //  this.nextScreen(item, type)
                                    }}
                                    style={{
                                        flex: .2,
                                        height: moderateScale(32),
                                        backgroundColor: Colors.colorPrimary,
                                        borderTopEndRadius: moderateScale(14),
                                        borderBottomEndRadius: moderateScale(14),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView
                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                        text={i18n.t('constant.Search')}
                                        type={"bold"}
                                        style={{
                                            textAlign: "center",
                                            color: Colors.white,
                                            fontSize: moderateScale(13)

                                        }}/>
                                </TouchableOpacity>

                            </View>
                            <View
                                style={{
                                    marginVertical: moderateScale(4),
                                    marginHorizontal: moderateScale(12),
                                    flexDirection: 'column',
                                }}>
                                <FlatList
                                    //style={{height: moderateScale(36)}}
                                    //    data={result.items}
                                    data={this.props.ListFilter ? this.props.ListFilter : []}
                                    // data={[
                                    //     {
                                    //
                                    //         type: '1',
                                    //         name: 'وضعیت پیام',
                                    //
                                    //     },
                                    //     {
                                    //
                                    //         type: '2',
                                    //         name: 'واحد اجرایی',
                                    //     },
                                    //
                                    //     // {
                                    //     //
                                    //     //     type: '3',
                                    //     //     name: 'تاریخ',
                                    //     // },
                                    //
                                    // ]}
                                    //   numColumns={3}
                                    renderItem={this.renderItemFilter}
                                    horizontal={true}
                                    showsHorizontalScrollIndicator={false}
                                    keyExtractor={(item, index) => index.toString()}
                                    inverted={Platform.OS === 'android' && i18n.locale == 'fa'}


                                />
                            </View>

                            <EmptyView empty={this.props.empty}/>
                            {/*    <FlatList
                                data={this.props.results}
                                //data={this.state.list}
                                extraData={{
                                    heightSlider: heightSlider,
                                    list: this.state.list,
                                }}
                                renderItem={({item, index}) => {
                                    return <View
                                        style={{
                                            flex: 1,
                                            marginVertical: moderateScale(10),
                                            marginHorizontal: moderateScale(10),
                                            borderRadius: moderateScale(10),
                                            overflow: 'hidden'

                                            // alignItems: 'center'
                                        }}>

                                        <View
                                            style={{
                                                width: "100%",
                                                backgroundColor: Colors.white,
                                            }}>
                                            <View
                                                style={{
                                                    width: "100%",
                                                    // height: this.state.viewportWidth / 1.6,
                                                    height: heightSlider,
                                                    //marginTop:moderateScale(6),
                                                    // backgroundColor:"#2bee8f"
                                                }}
                                                      // onPress={() => {
                                                      //     //alert("fghf")
                                                      //     if (container.state.backClickCount === 1) {
                                                      //         //  alert(" " + container.state.backClickCount)
                                                      //         container.setState({backClickCount: 0});
                                                      //         container.setLike(item, index);
                                                      //
                                                      //
                                                      //     } else {
                                                      //         container.setState({backClickCount: 1}, () => {
                                                      //
                                                      //                 setTimeout(function () {
                                                      //                     container.setState({backClickCount: 0},
                                                      //                         () => {
                                                      //
                                                      //                             // onPressLike()
                                                      //                             // alert("  " + container.state.backClickCount)
                                                      //                         });
                                                      //
                                                      //                 }, 300)
                                                      //
                                                      //             }
                                                      //         )
                                                      //     }
                                                      //
                                                      // }}

                                            >

                                                <HMSwiper
                                                    list={item.slider}
                                                    notLoop
                                                    notClick
                                                    notAutoPlay

                                                    renderItem={() => {
                                                        return item.slider.map((itemSwiper, indexSwiper) => {
                                                            let tttt = this.state["isLoading" + index + "SetDisplayImage" + indexSwiper];

                                                            return <DynamicContentSlide
                                                                itemSwiper={itemSwiper}
                                                                indexSwiper={indexSwiper}
                                                                index={index}
                                                                item={item}
                                                                // _key={indexSwiper + "_" + index}
                                                                // key={indexSwiper + "_" + index}
                                                                // loadingDisplayImage={this.state["isLoading" + index + "SetDisplayImage" + indexSwiper]}
                                                                loadingDisplayImage={tttt}
                                                                /// loadingDisplayImage={container.state.lllll}
                                                                // nameeee={"isLoading" + index + "SetDisplayImage" + indexSwiper}
                                                                // stateeee={this.state}

                                                                onPressLike={() => {
                                                                    // if (container.state.backClickCount === 1) {
                                                                    if (backClickCount_value) {
                                                                        //  alert(" " + container.state.backClickCount)
                                                                        // container.setState({backClickCount: 0});
                                                                        backClickCount_value = 0
                                                                        container.setLike(item, index);


                                                                    } else {
                                                                        // container.setState({backClickCount: 1}, () => {
                                                                        //
                                                                        //         setTimeout(function () {
                                                                        //             container.setState({backClickCount: 0},
                                                                        //                 () => {
                                                                        //
                                                                        //                     // onPressLike()
                                                                        //                     // alert("  " + container.state.backClickCount)
                                                                        //                 });
                                                                        //
                                                                        //         }, 300)
                                                                        //
                                                                        //     }
                                                                        // )

                                                                        backClickCount_value = 1;
                                                                        setTimeout(function () {
                                                                            backClickCount_value = 0;
                                                                        }, 200)

                                                                    }
                                                                }}

                                                                onPress={() => {
// const some_array = [...this.state.list]
                                                                    //
                                                                    // some_array[index].slider[indexSwiper].display = !this.state.list[index].slider[indexSwiper].display
                                                                    //
                                                                    // this.setState({list: some_array}
                                                                    //     ,
                                                                    //     () => {
                                                                    //     }
                                                                    // )

                                                                    const formData = new FormData();
                                                                    formData.append('lang', i18n.locale);
                                                                    formData.append('record', item.id);
                                                                    formData.append('recordChild', itemSwiper.id);
                                                                    formData.append('_session', container.props.token);
                                                                    formData.append('_operation', typeExport._Shahrdar);
                                                                    // // formData.append('lang', params.lang);
                                                                    formData.append('mode', "SetLikeFile");


                                                                    store.dispatch(serviceActionSetDisplayImage(!itemSwiper.display, index, indexSwiper))
                                                                    this.setData(() => {
                                                                    }, formData, index + "SetDisplayImage" + indexSwiper)


                                                                }}
                                                            />

                                                        })
                                                    }}

                                                />



                                                <TouchableOpacity
                                                    style={{
                                                        position: 'absolute',
                                                        bottom: moderateScale(22),
                                                        right: moderateScale(10),
                                                        // width: moderateScale(50),
                                                        height: moderateScale(34),
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderRadius: moderateScale(8),
                                                        backgroundColor: Colors.white,
                                                        borderWidth: moderateScale(1),
                                                        borderColor: Colors.colorPrimary,
                                                        //    padding:moderateScale(14)


                                                    }}
                                                    onPress={() => {
                                                        NavigationService.navigateParams("DetailsOperatorApplyScreen", {item: item})

                                                    }}
                                                >
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.messageno}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(14),
                                                            marginHorizontal: moderateScale(8)

                                                        }}/>
                                                </TouchableOpacity>
                                            </View>

                                            <View
                                                style={{
                                                    flex: 1,
                                                    flexDirection: 'row',
                                                    paddingHorizontal: moderateScale(10),
                                                    alignItems: 'center',
                                                }}>
                                                <TouchableOpacity style={{
                                                    width: moderateScale(30),
                                                    height: moderateScale(30),
                                                    alignItems: 'center', justifyContent: 'center',


                                                }}
                                                                  onPress={() => {
                                                                      this.setLike(item, index)
                                                                  }}

                                                >
                                                    <HMIcon
                                                        type={"Entypo"}
                                                        // type={"FontAwesome"}
                                                        //   type={"AntDesign"}
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        // name={item.like ? "send" : "send-o"}
                                                        //   name={item.like ? "ios-checkmark-circle" : "ios-checkmark-circle-outline"}
                                                        name={"publish"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, item.like ? {
                                                            color: "#ee0003"
                                                        } : {
                                                            color: "#6f6f6f"
                                                        }]}/>
                                                        {
                                                        // this.state["isLoading" + "setLike" + index] ?
                                                        //     <View style={{position: 'absolute'}}>
                                                        //         <ActivityIndicator color={Colors.colorPrimary}
                                                        //                            size={"large"}/>
                                                        //     </View>
                                                        //     :
                                                        //     null
                                                    }

                                                </TouchableOpacity>
                                                <TouchableOpacity style={{
                                                    width: moderateScale(30),
                                                    height: moderateScale(30),
                                                    alignItems: 'center', justifyContent: 'center',
                                                    marginHorizontal: moderateScale(10)


                                                }}
                                                                  onPress={() => {
                                                                      NavigationService.navigateParams("ListMessageChatScreen", {item: item})
                                                                  }}

                                                >
                                                    <HMIcon
                                                        //  type={"FontAwesome"}
                                                        type={"Feather"}
                                                        //  type={"AntDesign"}
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        //   name={item.like ? "send" : "send-o"}
                                                        name={item.like ? "send" : "send"}
                                                        // name={item.like ? "ios-checkmark-circle" : "ios-checkmark-circle-outline"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)},
                                                            //     item.like ? {
                                                            //     color: "#ee0003"
                                                            // } :
                                                            {
                                                                color: "#6f6f6f"
                                                            }]}/>
                                                        {
                                                        // this.state["isLoading" + "setLike" + index] ?
                                                        //     <View style={{position: 'absolute'}}>
                                                        //         <ActivityIndicator color={Colors.colorPrimary}
                                                        //                            size={"large"}/>
                                                        //     </View>
                                                        //     :
                                                        //     null
                                                    }

                                                </TouchableOpacity>
                                                <TouchableOpacity
                                                    style={{
                                                        width: moderateScale(30),
                                                        height: moderateScale(30),
                                                        alignItems: 'center', justifyContent: 'center',
                                                        //    borderWidth: moderateScale(2),
                                                        //  borderColor: Colors.colorDarkText,


                                                    }}
                                                    onPress={() => {

                                                        this.setState({
                                                            showModal: "selectImage",
                                                            index: index,
                                                            item: item,

                                                        })
                                                    }}
                                                >
                                                    {
                                                        this.state["isLoadingUpload" + index] ?
                                                            <View style={{}}>
                                                                <ActivityIndicator color={Colors.colorPrimary}
                                                                                   size={moderateScale(34)}/>
                                                            </View>
                                                            :
                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}
                                                                // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                name={"image-plus"}
                                                                //resizeMode="stretch"
                                                                style={[{fontSize: moderateScale(30)}, {
                                                                    color: Colors.colorDarkText,
                                                                }]}/>
                                                    }


                                                </TouchableOpacity>


                                                   <TouchableOpacity style={{
                                                    width: moderateScale(30),
                                                    height: moderateScale(30),
                                                    alignItems: 'center', justifyContent: 'center',


                                                }}>
                                                    <HMIcon
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"ios-share-social-outline"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, {
                                                            color: Colors.colorDarkText,
                                                        }]}/>

                                                </TouchableOpacity>



                                                <TouchableOpacity
                                                    style={{
                                                        width: moderateScale(30),
                                                        height: moderateScale(30),
                                                        alignItems: 'center', justifyContent: 'center',

                                                        marginHorizontal: moderateScale(10)

                                                    }}
                                                    onPress={() => {
                                                        this.setState({
                                                            showModal: "addComment",
                                                            comment: null,

                                                            index: index,
                                                            item: item,
                                                        })

                                                    }}
                                                >
                                                    <HMIcon
                                                        type={"FontAwesome"}

                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"comment-o"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, {
                                                            color: Colors.colorDarkText,
                                                        }]}/>
                                                    {
                                                        this.state["isLoading" + "AddComment" + index] ?
                                                            <View style={{position: 'absolute', top: moderateScale(6)}}>
                                                                <ActivityIndicator color={Colors.colorPrimary}
                                                                                   size={"small"}/>
                                                            </View>
                                                            :
                                                            null
                                                    }
                                                </TouchableOpacity>
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        if (Platform.OS === "web" && !navigator.share) {
                                                            // alert(typeExport._Url137 + "details_gallery_operation/" + item.id)
                                                            alert(item.sharing)

                                                        }
                                                        else
                                                            Tools.onShare({
                                                                // link_url: typeExport._Url137 + "details_gallery_operation/" + item.id,
                                                                link_url: item.sharing,
                                                                description: "این پست را دوست شما برای شما فرستاده لطفا مشاهد نمایید"
                                                            });


                                                    }}
                                                    style={{
                                                        width: moderateScale(30),
                                                        height: moderateScale(30),
                                                        alignItems: 'center', justifyContent: 'center',
                                                        // marginHorizontal: moderateScale(12),
                                                        //  backgroundColor:"#72ee3b"

                                                    }}>
                                                    <HMIcon
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"ios-share-social-outline"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, {
                                                            color: Colors.colorDarkText,
                                                        }]}/>

                                                </TouchableOpacity>

                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        alignItems: 'center', justifyContent: 'center',
                                                        marginHorizontal: moderateScale(8)


                                                    }}


                                                >
                                                    <HMIcon
                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                        name={"md-heart"}
                                                        //resizeMode="stretch"
                                                        style={[{fontSize: moderateScale(30)}, {
                                                            color: "#ee0003"
                                                        }]}/>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={`${item.count_like ? item.count_like : 0} نفر پسند شده`}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.colorDarkText,
                                                            fontSize: moderateScale(13),
                                                            marginHorizontal: moderateScale(2)

                                                        }}/>
                                                </View>

                                                <View style={{flex: 1}}/>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.createdtime}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(13),
                                                        marginHorizontal: moderateScale(2)

                                                    }}/>
                                            </View>
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    flex: 1,
                                                    //  width:'100%',
                                                    //   justifyContent: "flex-end",
                                                    flexWrap: 'wrap',
                                                    marginHorizontal: moderateScale(12),
                                                    marginVertical: moderateScale(6),

                                                }}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={"موضوع" + " : "}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14)

                                                    }}/>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.title}
                                                    type={"bold"}
                                                    style={{
                                                        //  textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(14)

                                                    }}
                                                    styleRoot={{
                                                        flexDirection: 'row',
                                                        flex: 1,
                                                        // justifyContent: "flex-end",
                                                        flexWrap: 'wrap',
                                                        //    alignItems: 'center', justifyContent: 'center'
                                                    }}
                                                />
                                            </View>
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    flex: 1,
                                                    //  width:'100%',
                                                    //   justifyContent: "flex-end",
                                                    flexWrap: 'wrap',
                                                    marginHorizontal: moderateScale(12),
                                                    marginVertical: moderateScale(6),

                                                }}>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={"آدرس" + " : "}
                                                    type={"bold"}
                                                    style={{
                                                        textAlign: "center",
                                                        color: Colors.blackLight,
                                                        fontSize: moderateScale(14)

                                                    }}/>
                                                <HMTextView
                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                    text={item.address}
                                                    type={"bold"}
                                                    style={{
                                                        //  textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(14)

                                                    }}
                                                    styleRoot={{
                                                        flexDirection: 'row',
                                                        flex: 1,
                                                        // justifyContent: "flex-end",
                                                        flexWrap: 'wrap',
                                                        //    alignItems: 'center', justifyContent: 'center'
                                                    }}
                                                />
                                            </View>
                                            <View style={{marginBottom: moderateScale(8)}}>
                                                {
                                                    item.lastWork ?
                                                        item.lastWork.map((itemWork, indexWork) => {
                                                            return <View
                                                                key={indexWork}
                                                                style={{
                                                                    flex: 1,
                                                                    flexDirection: 'row',

                                                                    //  width:'100%',
                                                                    //   justifyContent: "flex-end",
                                                                    flexWrap: 'wrap',
                                                                    //alignItems: 'center',
                                                                    marginHorizontal: moderateScale(12),
                                                                    marginVertical: moderateScale(5),
                                                                    borderWidth: moderateScale(.7),
                                                                    borderRadius: moderateScale(2),

                                                                    borderColor: '#ddd',
                                                                    borderBottomWidth: moderateScale(.7),
                                                                    shadowColor: '#000',
                                                                    shadowOffset: {width: 0, height: moderateScale(.7)},
                                                                    shadowOpacity: 0.6,
                                                                    shadowRadius: moderateScale(2),
                                                                    elevation: moderateScale(1),

                                                                    // borderRadius: moderateScale(8),
                                                                    margin: moderateScale(8),
                                                                    padding: moderateScale(10),
                                                                    // backgroundColor:"#F2F2F2"
                                                                }}>
                                                                <TouchableOpacity
                                                                    style={{
                                                                        width: moderateScale(28),
                                                                        height: moderateScale(28),
                                                                        alignItems: 'center', justifyContent: 'center',
                                                                    }}
                                                                    onPress={() => {
                                                                        const formData = new FormData();
                                                                        formData.append('lang', i18n.locale);
                                                                        formData.append('record', item.id);
                                                                        formData.append('recordChild', itemWork.id);
                                                                        formData.append('_session', container.props.token);
                                                                        formData.append('_operation', typeExport._Shahrdar);
                                                                        // // formData.append('lang', params.lang);
                                                                        formData.append('mode', "SetLikeComment");
                                                                        store.dispatch(serviceActionSetDisplayComment(!itemWork.display, index, indexWork))

                                                                        this.setData(() => {
                                                                        }, formData, index + "SetDisplayComment" + indexWork)
                                                                        // const some_array = [...this.state.list]
                                                                        //
                                                                        // some_array[index].lastWork[indexWork].display = !this.state.list[index].lastWork[indexWork].display
                                                                        //
                                                                        // this.setState({list: some_array}
                                                                        //     ,
                                                                        //     () => {
                                                                        //     }
                                                                        // )
                                                                    }}

                                                                >
                                                                    <HMIcon
                                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                        name={itemWork.display ? "md-eye" : "eye-off"}
                                                                        //resizeMode="stretch"
                                                                        style={[{fontSize: moderateScale(28)},
                                                                            {
                                                                                color: Colors.colorSecondPrimary
                                                                            }
                                                                        ]}/>
                                                                        {
                                                                        // this.state["isLoading" + index + "SetDisplayComment" + indexWork] ?
                                                                        //     <View style={{position: 'absolute',}}>
                                                                        //         <ActivityIndicator
                                                                        //             color={Colors.colorPrimary}
                                                                        //             size={"large"}/>
                                                                        //     </View>
                                                                        //     :
                                                                        //     null
                                                                    }
                                                                </TouchableOpacity>
                                                                <TouchableOpacity style={{
                                                                    width: moderateScale(26),
                                                                    height: moderateScale(26),
                                                                    alignItems: 'center', justifyContent: 'center',
                                                                    marginHorizontal: moderateScale(8)


                                                                }}
                                                                                  onPress={() => {
                                                                                      valueComment = itemWork.comment;
                                                                                      this.setState({
                                                                                              showModal: true,
                                                                                              comment: itemWork.comment,

                                                                                              index: index,
                                                                                              indexWork: indexWork,
                                                                                              item: item,
                                                                                              itemWork: itemWork,
                                                                                          },

                                                                                          () => {
                                                                                              if (this.refInputTextComment)
                                                                                                  this.refInputTextComment.setNativeProps({text: itemWork.comment});

                                                                                          }
                                                                                      )

                                                                                  }}
                                                                >
                                                                    <HMIcon
                                                                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                        name={"pencil-sharp"}
                                                                        //resizeMode="stretch"
                                                                        style={[{fontSize: moderateScale(24)}, {
                                                                            color: "#6f6f6f"
                                                                        }]}/>
                                                                        {
                                                                        // this.state["isLoading" + index + "SetComment" + indexWork] ?
                                                                        //     <View style={{position: 'absolute',}}>
                                                                        //         <ActivityIndicator
                                                                        //             color={Colors.colorPrimary}
                                                                        //             size={'large'}/>
                                                                        //     </View>
                                                                        //     :
                                                                        //     null
                                                                    }
                                                                </TouchableOpacity>
                                                                <View
                                                                    style={{
                                                                        flexDirection: Platform.OS==="web"&& this.state.viewportWidth>800?"row":"column",
                                                                        flex: 1,
                                                                        //  width:'100%',
                                                                        //   justifyContent: "flex-end",
                                                                        flexWrap: 'wrap',
                                                                        marginHorizontal: moderateScale(12),
                                                                        marginVertical: moderateScale(6),

                                                                    }}>
                                                                    <HMTextView
                                                                        //                                                    flexDirection: Platform.OS==="web"&& this.state.viewportWidth>800?"row":"column",
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={itemWork.title + " : "}
                                                                        type={"bold"}
                                                                        style={{
                                                                            textAlign: "center",
                                                                            color: Colors.blackLight,
                                                                            fontSize: moderateScale(14)

                                                                        }}/>
                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={itemWork.comment}
                                                                        type={"bold"}
                                                                        style={{
                                                                            //  textAlign: "center",
                                                                            color: Colors.colorDark,
                                                                            fontSize: moderateScale(14)

                                                                        }}

                                                                        styleRoot={{
                                                                            //  flexDirection: "row",
                                                                            flex: 1,
                                                                            //  width:'100%',
                                                                            //   justifyContent: "flex-end",
                                                                            flexWrap: 'wrap',

                                                                        }}
                                                                    />
                                                                </View>


                                                            </View>
                                                        })
                                                        :
                                                        null
                                                }
                                                   <FlatList
                                                    style={{height: moderateScale(30)}}
                                                    data={item.lastWork}
                                                    //  data={this.props.ListFilter ? this.props.ListFilter : []}
                                                    // data={[
                                                    //     {
                                                    //
                                                    //         type: '1',
                                                    //         name: 'وضعیت پیام',
                                                    //
                                                    //     },
                                                    //     {
                                                    //
                                                    //         type: '2',
                                                    //         name: 'واحد اجرایی',
                                                    //     },
                                                    //
                                                    //     // {
                                                    //     //
                                                    //     //     type: '3',
                                                    //     //     name: 'تاریخ',
                                                    //     // },
                                                    //
                                                    // ]}
                                                    //   numColumns={3}
                                                    renderItem={({item: itemWork, index: indexWork}) => {

                                                        return <View
                                                            style={{
                                                            flex: 1,
                                                            flexDirection: 'row',
                                                            backgroundColor: Colors.white,
                                                            borderRadius: moderateScale(8),
                                                            margin: moderateScale(8),
                                                            padding: moderateScale(10)
                                                        }}>
                                                            <TouchableOpacity style={{
                                                                width: moderateScale(28),
                                                                height: moderateScale(28),
                                                                alignItems: 'center', justifyContent: 'center',


                                                            }}>
                                                                <HMIcon
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"md-eye"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(28)}, itemWork.display ?
                                                                        {
                                                                            color: Colors.colorSecondPrimary
                                                                        }
                                                                        :
                                                                        {
                                                                            color: "#6f6f6f"
                                                                        }]}/>

                                                            </TouchableOpacity>
                                                            <TouchableOpacity style={{
                                                                width: moderateScale(26),
                                                                height: moderateScale(26),
                                                                alignItems: 'center', justifyContent: 'center',
                                                                marginHorizontal: moderateScale(8)


                                                            }}>
                                                                <HMIcon
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"pencil-sharp"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(24)}, {
                                                                        color: "#6f6f6f"
                                                                    }]}/>

                                                            </TouchableOpacity>

                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={itemWork.title + " : "}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14)

                                                                }}/>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={itemWork.comment}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(14)

                                                                }}/>
                                                        </View>
                                                    }}
                                                    showsHorizontalScrollIndicator={false}
                                                    keyExtractor={(item, index) => index.toString()}
                                                    // inverted={Platform.OS === 'android' && i18n.locale == 'fa'}

                                                    scrollEnabled={false}



                                                />

                                            </View>

                                        </View>

                                    </View>
                                }}
                                keyExtractor={(item, index) => index.toString()}
                                // ItemSeparatorComponent={() => <View style={{
                                //     height: moderateScale(1),
                                //     width: "100%",
                                //     backgroundColor: "rgba(0,0,0,0.5)",
                                //     marginVertical: moderateScale(10),
                                // }}
                                // />
                                // }
                                ListEmptyComponent={() =>
                                    null}
                                ListFooterComponent={this.renderFooter.bind(this)}
                                refreshing={this.props.showRefresh}
                                onRefresh={this.handleRefresh.bind(this)}
                                onEndReached={this.handleLoadMore.bind(this)}
                                initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                                // Performance settings
                                removeClippedSubviews={true} // Unmount components when outside of window
                                //initialNumToRender={2} // Reduce initial render amount
                                maxToRenderPerBatch={1} // Reduce number in each render batch
                                updateCellsBatchingPeriod={100} // Increase time between renders
                                windowSize={201} // Reduce the window size
                                // numColumns={this.state.columnCount}
                                // key={this.state.columnCount}
                            />*/}
                            <View style={{flex: 1,}}>
                                {this.props.results && this.props.results.length > 0 ? (
                                    <HMRecycleView
                                        style={{flex: 1}}
                                        contentContainerStyle={{margin: 3}}
                                        onEndReached={this.handleLoadMore.bind(this)}
                                        dataProvider={this.state.dataProvider.cloneWithRows(this.props.results)}
                                        layoutProvider={this.state.layoutProvider}
                                        renderAheadOffset={0}
                                        canChangeSize={this.state.canChangeSize}
                                        forceNonDeterministicRendering={true}
                                        extendedState={{
                                            heightSlider: heightSlider,
                                            widthSlider: widthSlider,
                                            list: this.state.list,
                                        }}
                                        onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                        //   forceNonDeterministicRendering={true}


                                        //application
                                        rowRenderer={(type, item, index) => {
                                            if (Platform.OS !== "web") {
                                                item = type.item;
                                                index = type.index;
                                            }

                                            //if (index === 0)
                                            return <View
                                                style={{width: this.state.viewportWidth, alignItems: 'center'}}>
                                                <View
                                                    style={{
                                                        width: widthSlider,
                                                        marginVertical: moderateScale(10),
                                                        //  marginHorizontal: moderateScale(10),
                                                        borderRadius: moderateScale(10),
                                                        overflow: 'hidden',
                                                        // alignSelf:"center"

                                                        // alignItems: 'center'
                                                    }}>
                                                    {/*      <View style={{
                                                  //  flex:1,
                                                    width: widthSlider,
                                                    height: moderateScale(1),
                                                    backgroundColor: "transparent"
                                                }}/>*/}
                                                    <View
                                                        style={{
                                                            width: "100%",
                                                            backgroundColor: Colors.white,
                                                        }}>
                                                        <View
                                                            style={{
                                                                width: "100%",
                                                                // height: this.state.viewportWidth / 1.6,
                                                                height: heightSlider,
                                                                //marginTop:moderateScale(6),
                                                                // backgroundColor:"#2bee8f"
                                                            }}
                                                            // onPress={() => {
                                                            //     //alert("fghf")
                                                            //     if (container.state.backClickCount === 1) {
                                                            //         //  alert(" " + container.state.backClickCount)
                                                            //         container.setState({backClickCount: 0});
                                                            //         container.setLike(item, index);
                                                            //
                                                            //
                                                            //     } else {
                                                            //         container.setState({backClickCount: 1}, () => {
                                                            //
                                                            //                 setTimeout(function () {
                                                            //                     container.setState({backClickCount: 0},
                                                            //                         () => {
                                                            //
                                                            //                             // onPressLike()
                                                            //                             // alert("  " + container.state.backClickCount)
                                                            //                         });
                                                            //
                                                            //                 }, 300)
                                                            //
                                                            //             }
                                                            //         )
                                                            //     }
                                                            //
                                                            // }}

                                                        >
                                                            {
                                                                item.slider && item.slider.length > 0 ?
                                                                    <HMSwiper
                                                                        list={item.slider}
                                                                        notLoop
                                                                        notClick
                                                                        notAutoPlay
                                                                        item={item}
                                                                        renderItem={() => {
                                                                            return item.slider.map((itemSwiper, indexSwiper) => {
                                                                                let tttt = this.state["isLoading" + index + "SetDisplayImage" + indexSwiper];

                                                                                return <DynamicContentSlide
                                                                                    itemSwiper={itemSwiper}
                                                                                    indexSwiper={indexSwiper}
                                                                                    index={index}
                                                                                    item={item}
                                                                                    itemParent={data}
                                                                                    // _key={indexSwiper + "_" + index}
                                                                                    //key={indexSwiper + "_" + index}
                                                                                    // loadingDisplayImage={this.state["isLoading" + index + "SetDisplayImage" + indexSwiper]}
                                                                                    loadingDisplayImage={tttt}
                                                                                    /// loadingDisplayImage={container.state.lllll}
                                                                                    // nameeee={"isLoading" + index + "SetDisplayImage" + indexSwiper}
                                                                                    // stateeee={this.state}

                                                                                    onPressLike={() => {
                                                                                        // if (container.state.backClickCount === 1) {
                                                                                        if (backClickCount_value) {
                                                                                            //  alert(" " + container.state.backClickCount)
                                                                                            // container.setState({backClickCount: 0});
                                                                                            backClickCount_value = 0
                                                                                            container.setLike(item, index);


                                                                                        } else {
                                                                                            // container.setState({backClickCount: 1}, () => {
                                                                                            //
                                                                                            //         setTimeout(function () {
                                                                                            //             container.setState({backClickCount: 0},
                                                                                            //                 () => {
                                                                                            //
                                                                                            //                     // onPressLike()
                                                                                            //                     // alert("  " + container.state.backClickCount)
                                                                                            //                 });
                                                                                            //
                                                                                            //         }, 300)
                                                                                            //
                                                                                            //     }
                                                                                            // )

                                                                                            backClickCount_value = 1;
                                                                                            setTimeout(function () {
                                                                                                backClickCount_value = 0;
                                                                                            }, 200)

                                                                                        }
                                                                                    }}

                                                                                    onPress={() => {
// const some_array = [...this.state.list]
                                                                                        //
                                                                                        // some_array[index].slider[indexSwiper].display = !this.state.list[index].slider[indexSwiper].display
                                                                                        //
                                                                                        // this.setState({list: some_array}
                                                                                        //     ,
                                                                                        //     () => {
                                                                                        //     }
                                                                                        // )

                                                                                        const formData = new FormData();
                                                                                        formData.append('lang', i18n.locale);
                                                                                        // formData.append('record', item.id);
                                                                                        let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) && false ? item.tracking_code : item.id;
                                                                                        formData.append('record', id);
                                                                                        formData.append('recordChild', itemSwiper.id);
                                                                                        formData.append('_session', container.props.token);
                                                                                        formData.append('_operation', typeExport._Shahrdar);
                                                                                        // // formData.append('lang', params.lang);
                                                                                        formData.append('mode', "SetLikeFile");


                                                                                        store.dispatch(serviceActionSetDisplayImage(!itemSwiper.display, index, indexSwiper))
                                                                                        this.setData(() => {
                                                                                        }, formData, index + "SetDisplayImage" + indexSwiper)


                                                                                    }}
                                                                                />

                                                                            })
                                                                        }}

                                                                    />
                                                                    :
                                                                    <View
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            backgroundColor: Colors.gray,
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                        }}
                                                                    >
                                                                        <HMIcon
                                                                            type={"FontAwesome"}
                                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                            name={"picture-o"}
                                                                            //resizeMode="stretch"
                                                                            style={[{fontSize: moderateScale(48)}, {
                                                                                color: Colors.white
                                                                            }]}/>
                                                                    </View>

                                                            }

                                                            <TouchableOpacity
                                                                style={{
                                                                    position: 'absolute',
                                                                    bottom: moderateScale(22),
                                                                    right: moderateScale(10),
                                                                    // width: moderateScale(50),
                                                                    height: moderateScale(34),
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    borderRadius: moderateScale(8),
                                                                    backgroundColor: Colors.white,
                                                                    borderWidth: moderateScale(1),
                                                                    borderColor: Colors.colorPrimary,
                                                                    //    padding:moderateScale(14)


                                                                }}
                                                                onPress={() => {
                                                                    NavigationService.navigateParams("DetailsOperatorApplyScreen", {item: item})

                                                                }}
                                                            >
                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={item.messageno}
                                                                    type={"bold"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: Colors.colorDarkText,
                                                                        fontSize: moderateScale(14),
                                                                        marginHorizontal: moderateScale(8)

                                                                    }}/>
                                                            </TouchableOpacity>
                                                        </View>

                                                        <View
                                                            style={{
                                                                flex: 1,
                                                                flexWrap: 'wrap',
                                                                flexDirection: 'row',
                                                                paddingHorizontal: moderateScale(10),
                                                                alignItems: 'center',

                                                            }}>
                                                            {
                                                                data.type == 10 ?
                                                                    null
                                                                    :
                                                                    <TouchableOpacity
                                                                        style={{
                                                                            width: moderateScale(24),
                                                                            height: moderateScale(24),
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            marginHorizontal: moderateScale(3),

                                                                        }}
                                                                        onPress={() => {
                                                                            this.setLike(item, index)
                                                                        }}

                                                                    >
                                                                        <HMIcon
                                                                            type={"Entypo"}
                                                                            // type={"FontAwesome"}
                                                                            //   type={"AntDesign"}
                                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                            // name={item.like ? "send" : "send-o"}
                                                                            //   name={item.like ? "ios-checkmark-circle" : "ios-checkmark-circle-outline"}
                                                                            name={"publish"}
                                                                            //resizeMode="stretch"
                                                                            style={[{fontSize: moderateScale(24)}, item.like ? {
                                                                                color: "#ee0003"
                                                                            } : {
                                                                                color: "#6f6f6f"
                                                                            }]}/>
                                                                        {
                                                                            // this.state["isLoading" + "setLike" + index] ?
                                                                            //     <View style={{position: 'absolute'}}>
                                                                            //         <ActivityIndicator color={Colors.colorPrimary}
                                                                            //                            size={"large"}/>
                                                                            //     </View>
                                                                            //     :
                                                                            //     null
                                                                        }

                                                                    </TouchableOpacity>
                                                            }
                                                            <TouchableOpacity
                                                                style={{
                                                                    width: moderateScale(24),
                                                                    height: moderateScale(24),
                                                                    alignItems: 'center', justifyContent: 'center',
                                                                    marginHorizontal: moderateScale(3)


                                                                }}
                                                                onPress={() => {
                                                                    NavigationService.navigateParams(checkClick ? "ListUserChatScreen" : "ListUserChatScreen_Root", {extraData: item})
                                                                }}

                                                            >
                                                                <HMIcon
                                                                    //  type={"FontAwesome"}
                                                                    type={"Feather"}
                                                                    //  type={"AntDesign"}
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    //   name={item.like ? "send" : "send-o"}
                                                                    name={item.like ? "send" : "send"}
                                                                    // name={item.like ? "ios-checkmark-circle" : "ios-checkmark-circle-outline"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(24)},
                                                                        //     item.like ? {
                                                                        //     color: "#ee0003"
                                                                        // } :
                                                                        {
                                                                            color: "#6f6f6f"
                                                                        }]}/>
                                                                {
                                                                    // this.state["isLoading" + "setLike" + index] ?
                                                                    //     <View style={{position: 'absolute'}}>
                                                                    //         <ActivityIndicator color={Colors.colorPrimary}
                                                                    //                            size={"large"}/>
                                                                    //     </View>
                                                                    //     :
                                                                    //     null
                                                                }

                                                            </TouchableOpacity>
                                                            <TouchableOpacity
                                                                style={{
                                                                    width: moderateScale(24),
                                                                    height: moderateScale(24),
                                                                    alignItems: 'center', justifyContent: 'center',
                                                                    //    borderWidth: moderateScale(2),
                                                                    //  borderColor: Colors.colorDarkText,
                                                                    marginHorizontal: moderateScale(3),


                                                                }}
                                                                onPress={() => {

                                                                    this.setState({
                                                                        showModal: "selectImage",
                                                                        index: index,
                                                                        item: item,

                                                                    })
                                                                }}
                                                            >
                                                                {
                                                                    this.state["isLoadingUpload" + index] ?
                                                                        <View style={{}}>
                                                                            <ActivityIndicator
                                                                                color={Colors.colorPrimary}
                                                                                size={moderateScale(34)}/>
                                                                        </View>
                                                                        :
                                                                        <HMIcon
                                                                            type={"MaterialCommunityIcons"}
                                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                            name={"image-plus"}
                                                                            //resizeMode="stretch"
                                                                            style={[{fontSize: moderateScale(30)}, {
                                                                                color: Colors.colorDarkText,
                                                                            }]}/>
                                                                }


                                                            </TouchableOpacity>


                                                            {/*<TouchableOpacity style={{*/}
                                                            {/*width: moderateScale(30),*/}
                                                            {/*height: moderateScale(30),*/}
                                                            {/*alignItems: 'center', justifyContent: 'center',*/}


                                                            {/*}}>*/}
                                                            {/*<HMIcon*/}
                                                            {/*// source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}*/}
                                                            {/*name={"ios-share-social-outline"}*/}
                                                            {/*//resizeMode="stretch"*/}
                                                            {/*style={[{fontSize: moderateScale(30)}, {*/}
                                                            {/*color: Colors.colorDarkText,*/}
                                                            {/*}]}/>*/}

                                                            {/*</TouchableOpacity>*/}


                                                            <TouchableOpacity
                                                                style={{
                                                                    width: moderateScale(24),
                                                                    height: moderateScale(24),
                                                                    alignItems: 'center', justifyContent: 'center',

                                                                    marginHorizontal: moderateScale(3),

                                                                }}
                                                                onPress={() => {
                                                                    this.setState({
                                                                        showModal: "addComment",
                                                                        comment: null,

                                                                        index: index,
                                                                        item: item,
                                                                    })

                                                                }}
                                                            >
                                                                <HMIcon
                                                                    type={"FontAwesome"}

                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"comment-o"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(24)}, {
                                                                        color: Colors.colorDarkText,
                                                                    }]}/>
                                                                {
                                                                    this.state["isLoading" + "AddComment" + index] ?
                                                                        <View style={{
                                                                            position: 'absolute',
                                                                            top: moderateScale(6)
                                                                        }}>
                                                                            <ActivityIndicator
                                                                                color={Colors.colorPrimary}
                                                                                size={"small"}/>
                                                                        </View>
                                                                        :
                                                                        null
                                                                }
                                                            </TouchableOpacity>
                                                            <TouchableOpacity
                                                                onPress={() => {
                                                                    if (Platform.OS === "web" && !navigator.share) {
                                                                        // alert(typeExport._Url137 + "details_gallery_operation/" + item.id)
                                                                        alert(item.sharing)

                                                                    }
                                                                    else
                                                                        Tools.onShare({
                                                                            // link_url: typeExport._Url137 + "details_gallery_operation/" + item.id,
                                                                            link_url: item.sharing,
                                                                            description: "این پست را دوست شما برای شما فرستاده لطفا مشاهد نمایید"
                                                                        });


                                                                }}
                                                                style={{
                                                                    width: moderateScale(24),
                                                                    height: moderateScale(24),
                                                                    alignItems: 'center', justifyContent: 'center',
                                                                    // marginHorizontal: moderateScale(12),
                                                                    //  backgroundColor:"#72ee3b"
                                                                    marginHorizontal: moderateScale(3),

                                                                }}>
                                                                <HMIcon
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"ios-share-social-outline"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(24)}, {
                                                                        color: Colors.colorDarkText,
                                                                    }]}/>

                                                            </TouchableOpacity>

                                                            <View
                                                                style={{
                                                                    flexDirection: "row",
                                                                    alignItems: 'center', justifyContent: 'center',
                                                                    marginHorizontal: moderateScale(3),


                                                                }}


                                                            >
                                                                <HMIcon
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"md-heart"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(24)}, {
                                                                        color: "#ee0003"
                                                                    }]}/>
                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={`${item.count_like ? item.count_like : 0} نفر پسند شده`}
                                                                    type={"bold"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: Colors.colorDarkText,
                                                                        fontSize: moderateScale(12),
                                                                        marginHorizontal: moderateScale(2)

                                                                    }}/>
                                                            </View>

                                                            <View style={{flex: 1}}/>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={item.createdtime}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(13),
                                                                    marginHorizontal: moderateScale(2)

                                                                }}/>
                                                            <View style={{width: moderateScale(6)}}/>
                                                            <View
                                                                style={{
                                                                    flexDirection: "row",
                                                                    alignItems: 'center', justifyContent: 'center',
                                                                    marginHorizontal: moderateScale(3),


                                                                }}


                                                            >

                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    //  text={`${item.count_like ? item.count_like : 0} نفر پسند شده`}

                                                                    text={item.count_view ? item.count_view : "0"}
                                                                    type={"bold"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: Colors.colorDark,
                                                                        fontSize: moderateScale(12),
                                                                        marginHorizontal: moderateScale(2)

                                                                    }}/>
                                                                <HMIcon
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"md-eye"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(22)}, {
                                                                        color: Colors.colorDarkText,
                                                                    }]}/>
                                                            </View>
                                                        </View>
                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                flex: 1,
                                                                //  width:'100%',
                                                                //   justifyContent: "flex-end",
                                                                flexWrap: 'wrap',
                                                                marginHorizontal: moderateScale(12),
                                                                marginVertical: moderateScale(6),

                                                            }}>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={"موضوع" + " : "}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14)

                                                                }}/>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={item.title}
                                                                type={"bold"}
                                                                style={{
                                                                    //  textAlign: "center",
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(14)

                                                                }}
                                                                styleRoot={{
                                                                    flexDirection: 'row',
                                                                    flex: 1,
                                                                    // justifyContent: "flex-end",
                                                                    flexWrap: 'wrap',
                                                                    //    alignItems: 'center', justifyContent: 'center'
                                                                }}
                                                            />
                                                        </View>
                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                flex: 1,
                                                                //  width:'100%',
                                                                //   justifyContent: "flex-end",
                                                                flexWrap: 'wrap',
                                                                marginHorizontal: moderateScale(12),
                                                                marginVertical: moderateScale(6),

                                                            }}>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={"آدرس" + " : "}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14)

                                                                }}/>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={item.address}
                                                                type={"bold"}
                                                                style={{
                                                                    //  textAlign: "center",
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(14)

                                                                }}
                                                                styleRoot={{
                                                                    flexDirection: 'row',
                                                                    flex: 1,
                                                                    // justifyContent: "flex-end",
                                                                    flexWrap: 'wrap',
                                                                    //    alignItems: 'center', justifyContent: 'center'
                                                                }}
                                                            />
                                                        </View>
                                                        <View style={{marginBottom: moderateScale(8)}}>
                                                            {
                                                                item.lastWork ?
                                                                    item.lastWork.map((itemWork, indexWork) => {
                                                                        return <View
                                                                            key={indexWork}
                                                                            style={{
                                                                                flex: 1,
                                                                                flexDirection: 'row',

                                                                                //  width:'100%',
                                                                                //   justifyContent: "flex-end",
                                                                                flexWrap: 'wrap',
                                                                                //alignItems: 'center',
                                                                                marginHorizontal: moderateScale(12),
                                                                                marginVertical: moderateScale(5),
                                                                                borderWidth: moderateScale(.7),
                                                                                borderRadius: moderateScale(2),

                                                                                borderColor: '#ddd',
                                                                                borderBottomWidth: moderateScale(.7),
                                                                                shadowColor: '#000',
                                                                                shadowOffset: {
                                                                                    width: 0,
                                                                                    height: moderateScale(.7)
                                                                                },
                                                                                shadowOpacity: 0.6,
                                                                                shadowRadius: moderateScale(2),
                                                                                elevation: moderateScale(1),

                                                                                // borderRadius: moderateScale(8),
                                                                                margin: moderateScale(8),
                                                                                padding: moderateScale(10),
                                                                                // backgroundColor:"#F2F2F2"
                                                                            }}>
                                                                            {
                                                                                data.type == 10 ?
                                                                                    null
                                                                                    :
                                                                                    <TouchableOpacity
                                                                                        style={{
                                                                                            width: moderateScale(28),
                                                                                            height: moderateScale(28),
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                        }}
                                                                                        onPress={() => {
                                                                                            const formData = new FormData();
                                                                                            formData.append('lang', i18n.locale);
                                                                                            //  formData.append('record', item.id);

                                                                                            let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) && false ? item.tracking_code : item.id;
                                                                                            formData.append('record', id);
                                                                                            formData.append('recordChild', itemWork.id);
                                                                                            formData.append('_session', container.props.token);
                                                                                            formData.append('_operation', typeExport._Shahrdar);
                                                                                            // // formData.append('lang', params.lang);
                                                                                            formData.append('mode', "SetLikeComment");
                                                                                            store.dispatch(serviceActionSetDisplayComment(!itemWork.display, index, indexWork))

                                                                                            this.setData(() => {
                                                                                            }, formData, index + "SetDisplayComment" + indexWork)
                                                                                            // const some_array = [...this.state.list]
                                                                                            //
                                                                                            // some_array[index].lastWork[indexWork].display = !this.state.list[index].lastWork[indexWork].display
                                                                                            //
                                                                                            // this.setState({list: some_array}
                                                                                            //     ,
                                                                                            //     () => {

                                                                                            //     }
                                                                                            // )
                                                                                        }}

                                                                                    >
                                                                                        <HMIcon
                                                                                            // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                                            name={itemWork.display ? "md-eye" : "eye-off"}
                                                                                            //resizeMode="stretch"
                                                                                            style={[{fontSize: moderateScale(28)},
                                                                                                {
                                                                                                    color: Colors.colorSecondPrimary
                                                                                                }
                                                                                            ]}/>
                                                                                        {
                                                                                            // this.state["isLoading" + index + "SetDisplayComment" + indexWork] ?
                                                                                            //     <View style={{position: 'absolute',}}>
                                                                                            //         <ActivityIndicator
                                                                                            //             color={Colors.colorPrimary}
                                                                                            //             size={"large"}/>
                                                                                            //     </View>
                                                                                            //     :
                                                                                            //     null
                                                                                        }
                                                                                    </TouchableOpacity>
                                                                            }
                                                                            <TouchableOpacity style={{
                                                                                width: moderateScale(26),
                                                                                height: moderateScale(26),
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                marginHorizontal: moderateScale(8)


                                                                            }}
                                                                                              onPress={() => {
                                                                                                  valueComment = itemWork.comment;
                                                                                                  this.setState({
                                                                                                          showModal: true,
                                                                                                          comment: itemWork.comment,

                                                                                                          index: index,
                                                                                                          indexWork: indexWork,
                                                                                                          item: item,
                                                                                                          itemWork: itemWork,
                                                                                                      },

                                                                                                      () => {
                                                                                                          if (this.refInputTextComment)
                                                                                                              this.refInputTextComment.setNativeProps({text: itemWork.comment});

                                                                                                      }
                                                                                                  )

                                                                                              }}
                                                                            >
                                                                                <HMIcon
                                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                                    name={"pencil-sharp"}
                                                                                    //resizeMode="stretch"
                                                                                    style={[{fontSize: moderateScale(24)}, {
                                                                                        color: "#6f6f6f"
                                                                                    }]}/>
                                                                                {
                                                                                    // this.state["isLoading" + index + "SetComment" + indexWork] ?
                                                                                    //     <View style={{position: 'absolute',}}>
                                                                                    //         <ActivityIndicator
                                                                                    //             color={Colors.colorPrimary}
                                                                                    //             size={'large'}/>
                                                                                    //     </View>
                                                                                    //     :
                                                                                    //     null
                                                                                }
                                                                            </TouchableOpacity>
                                                                            <View
                                                                                style={{
                                                                                    flexDirection: Platform.OS === "web" && this.state.viewportWidth > 800 ? "row" : "column",
                                                                                    flex: 1,
                                                                                    //  width:'100%',
                                                                                    //   justifyContent: "flex-end",
                                                                                    flexWrap: 'wrap',
                                                                                    marginHorizontal: moderateScale(12),
                                                                                    marginVertical: moderateScale(6),

                                                                                }}>
                                                                                <HMTextView
                                                                                    //                                                    flexDirection: Platform.OS==="web"&& this.state.viewportWidth>800?"row":"column",
                                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                    text={itemWork.title + " : "}
                                                                                    type={"bold"}
                                                                                    style={{
                                                                                        textAlign: "center",
                                                                                        color: Colors.blackLight,
                                                                                        fontSize: moderateScale(14)

                                                                                    }}/>
                                                                                <HMTextView
                                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                    text={itemWork.comment}
                                                                                    type={"bold"}
                                                                                    style={{
                                                                                        //  textAlign: "center",
                                                                                        color: Colors.colorDark,
                                                                                        fontSize: moderateScale(14)

                                                                                    }}

                                                                                    styleRoot={{
                                                                                        //  flexDirection: "row",
                                                                                        flex: 1,
                                                                                        //  width:'100%',
                                                                                        //   justifyContent: "flex-end",
                                                                                        flexWrap: 'wrap',

                                                                                    }}
                                                                                />
                                                                            </View>


                                                                        </View>
                                                                    })
                                                                    :
                                                                    null
                                                            }
                                                            {/*   <FlatList
                                                    style={{height: moderateScale(30)}}
                                                    data={item.lastWork}
                                                    //  data={this.props.ListFilter ? this.props.ListFilter : []}
                                                    // data={[
                                                    //     {
                                                    //
                                                    //         type: '1',
                                                    //         name: 'وضعیت پیام',
                                                    //
                                                    //     },
                                                    //     {
                                                    //
                                                    //         type: '2',
                                                    //         name: 'واحد اجرایی',
                                                    //     },
                                                    //
                                                    //     // {
                                                    //     //
                                                    //     //     type: '3',
                                                    //     //     name: 'تاریخ',
                                                    //     // },
                                                    //
                                                    // ]}
                                                    //   numColumns={3}
                                                    renderItem={({item: itemWork, index: indexWork}) => {

                                                        return <View
                                                            style={{
                                                            flex: 1,
                                                            flexDirection: 'row',
                                                            backgroundColor: Colors.white,
                                                            borderRadius: moderateScale(8),
                                                            margin: moderateScale(8),
                                                            padding: moderateScale(10)
                                                        }}>
                                                            <TouchableOpacity style={{
                                                                width: moderateScale(28),
                                                                height: moderateScale(28),
                                                                alignItems: 'center', justifyContent: 'center',


                                                            }}>
                                                                <HMIcon
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"md-eye"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(28)}, itemWork.display ?
                                                                        {
                                                                            color: Colors.colorSecondPrimary
                                                                        }
                                                                        :
                                                                        {
                                                                            color: "#6f6f6f"
                                                                        }]}/>

                                                            </TouchableOpacity>
                                                            <TouchableOpacity style={{
                                                                width: moderateScale(26),
                                                                height: moderateScale(26),
                                                                alignItems: 'center', justifyContent: 'center',
                                                                marginHorizontal: moderateScale(8)


                                                            }}>
                                                                <HMIcon
                                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                    name={"pencil-sharp"}
                                                                    //resizeMode="stretch"
                                                                    style={[{fontSize: moderateScale(24)}, {
                                                                        color: "#6f6f6f"
                                                                    }]}/>

                                                            </TouchableOpacity>

                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={itemWork.title + " : "}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14)

                                                                }}/>
                                                            <HMTextView
                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                text={itemWork.comment}
                                                                type={"bold"}
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(14)

                                                                }}/>
                                                        </View>
                                                    }}
                                                    showsHorizontalScrollIndicator={false}
                                                    keyExtractor={(item, index) => index.toString()}
                                                    // inverted={Platform.OS === 'android' && i18n.locale == 'fa'}

                                                    scrollEnabled={false}



                                                />*/}

                                                        </View>

                                                    </View>

                                                </View>
                                            </View>
                                        }}
                                        renderFooter={this.renderFooter.bind(this)}
                                        columnCount={this.state.columnCount}
                                        initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                        refreshing={this.props.showRefresh}
                                        keyExtractor={(item, index) => index.toString()}
                                        data={this.props.results}
                                    />
                                    /*   <RecyclerListView
                                           style={{flex: 1}}
                                           contentContainerStyle={{margin: 3}}
                                           onEndReached={this.handleLoadMore.bind(this)}
                                           dataProvider={this.state.dataProvider.cloneWithRows(this.props.results)}
                                           layoutProvider={this.state.layoutProvider}
                                           renderAheadOffset={0}
                                           canChangeSize={this.state.canChangeSize}
                                           forceNonDeterministicRendering={true}
                                           extendedState={{
                                               heightSlider: heightSlider,
                                               widthSlider: widthSlider,
                                               list: this.state.list,
                                           }}
                                           onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                           //   forceNonDeterministicRendering={true}
                                           rowRenderer={(type, item, index) => {

                                               //if (index === 0)
                                               return <View
                                                   style={{
                                                       width: widthSlider,
                                                       marginVertical: moderateScale(10),
                                                       //  marginHorizontal: moderateScale(10),
                                                       borderRadius: moderateScale(10),
                                                       overflow: 'hidden'

                                                       // alignItems: 'center'
                                                   }}>
                                                   {/!*      <View style={{
                                                     //  flex:1,
                                                       width: widthSlider,
                                                       height: moderateScale(1),
                                                       backgroundColor: "transparent"
                                                   }}/>*!/}
                                                   <View
                                                       style={{
                                                           width: "100%",
                                                           backgroundColor: Colors.white,
                                                       }}>
                                                       <View
                                                           style={{
                                                               width: "100%",
                                                               // height: this.state.viewportWidth / 1.6,
                                                               height: heightSlider,
                                                               //marginTop:moderateScale(6),
                                                               // backgroundColor:"#2bee8f"
                                                           }}
                                                           // onPress={() => {
                                                           //     //alert("fghf")
                                                           //     if (container.state.backClickCount === 1) {
                                                           //         //  alert(" " + container.state.backClickCount)
                                                           //         container.setState({backClickCount: 0});
                                                           //         container.setLike(item, index);
                                                           //
                                                           //
                                                           //     } else {
                                                           //         container.setState({backClickCount: 1}, () => {
                                                           //
                                                           //                 setTimeout(function () {
                                                           //                     container.setState({backClickCount: 0},
                                                           //                         () => {
                                                           //
                                                           //                             // onPressLike()
                                                           //                             // alert("  " + container.state.backClickCount)
                                                           //                         });
                                                           //
                                                           //                 }, 300)
                                                           //
                                                           //             }
                                                           //         )
                                                           //     }
                                                           //
                                                           // }}

                                                       >
                                                           {
                                                               item.slider && item.slider.length > 0 ?
                                                                   <HMSwiper
                                                                       list={item.slider}
                                                                       notLoop
                                                                       notClick
                                                                       notAutoPlay
                                                                       item={item}
                                                                       renderItem={() => {
                                                                           return item.slider.map((itemSwiper, indexSwiper) => {
                                                                               let tttt = this.state["isLoading" + index + "SetDisplayImage" + indexSwiper];

                                                                               return <DynamicContentSlide
                                                                                   itemSwiper={itemSwiper}
                                                                                   indexSwiper={indexSwiper}
                                                                                   index={index}
                                                                                   item={item}
                                                                                   // _key={indexSwiper + "_" + index}
                                                                                   //key={indexSwiper + "_" + index}
                                                                                   // loadingDisplayImage={this.state["isLoading" + index + "SetDisplayImage" + indexSwiper]}
                                                                                   loadingDisplayImage={tttt}
                                                                                   /// loadingDisplayImage={container.state.lllll}
                                                                                   // nameeee={"isLoading" + index + "SetDisplayImage" + indexSwiper}
                                                                                   // stateeee={this.state}

                                                                                   onPressLike={() => {
                                                                                       // if (container.state.backClickCount === 1) {
                                                                                       if (backClickCount_value) {
                                                                                           //  alert(" " + container.state.backClickCount)
                                                                                           // container.setState({backClickCount: 0});
                                                                                           backClickCount_value = 0
                                                                                           container.setLike(item, index);


                                                                                       } else {
                                                                                           // container.setState({backClickCount: 1}, () => {
                                                                                           //
                                                                                           //         setTimeout(function () {
                                                                                           //             container.setState({backClickCount: 0},
                                                                                           //                 () => {
                                                                                           //
                                                                                           //                     // onPressLike()
                                                                                           //                     // alert("  " + container.state.backClickCount)
                                                                                           //                 });
                                                                                           //
                                                                                           //         }, 300)
                                                                                           //
                                                                                           //     }
                                                                                           // )

                                                                                           backClickCount_value = 1;
                                                                                           setTimeout(function () {
                                                                                               backClickCount_value = 0;
                                                                                           }, 200)

                                                                                       }
                                                                                   }}

                                                                                   onPress={() => {
   // const some_array = [...this.state.list]
                                                                                       //
                                                                                       // some_array[index].slider[indexSwiper].display = !this.state.list[index].slider[indexSwiper].display
                                                                                       //
                                                                                       // this.setState({list: some_array}
                                                                                       //     ,
                                                                                       //     () => {
                                                                                       //     }
                                                                                       // )

                                                                                       const formData = new FormData();
                                                                                       formData.append('lang', i18n.locale);
                                                                                       formData.append('record', item.id);
                                                                                       formData.append('recordChild', itemSwiper.id);
                                                                                       formData.append('_session', container.props.token);
                                                                                       formData.append('_operation', typeExport._Shahrdar);
                                                                                       // // formData.append('lang', params.lang);
                                                                                       formData.append('mode', "SetLikeFile");


                                                                                       store.dispatch(serviceActionSetDisplayImage(!itemSwiper.display, index, indexSwiper))
                                                                                       this.setData(() => {
                                                                                       }, formData, index + "SetDisplayImage" + indexSwiper)


                                                                                   }}
                                                                               />

                                                                           })
                                                                       }}

                                                                   />
                                                                   :
                                                                   <View
                                                                       style={{
                                                                           width: '100%',
                                                                           height: '100%',
                                                                           backgroundColor: Colors.gray,
                                                                           alignItems: 'center',
                                                                           justifyContent: 'center',
                                                                       }}
                                                                   >
                                                                       <HMIcon
                                                                           type={"FontAwesome"}
                                                                           // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                           name={"picture-o"}
                                                                           //resizeMode="stretch"
                                                                           style={[{fontSize: moderateScale(48)}, {
                                                                               color: Colors.white
                                                                           }]}/>
                                                                   </View>

                                                           }

                                                           <TouchableOpacity
                                                               style={{
                                                                   position: 'absolute',
                                                                   bottom: moderateScale(22),
                                                                   right: moderateScale(10),
                                                                   // width: moderateScale(50),
                                                                   height: moderateScale(34),
                                                                   alignItems: 'center',
                                                                   justifyContent: 'center',
                                                                   borderRadius: moderateScale(8),
                                                                   backgroundColor: Colors.white,
                                                                   borderWidth: moderateScale(1),
                                                                   borderColor: Colors.colorPrimary,
                                                                   //    padding:moderateScale(14)


                                                               }}
                                                               onPress={() => {
                                                                   NavigationService.navigateParams("DetailsOperatorApplyScreen", {item: item})

                                                               }}
                                                           >
                                                               <HMTextView
                                                                   //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                   text={item.messageno}
                                                                   type={"bold"}
                                                                   style={{
                                                                       textAlign: "center",
                                                                       color: Colors.colorDarkText,
                                                                       fontSize: moderateScale(14),
                                                                       marginHorizontal: moderateScale(8)

                                                                   }}/>
                                                           </TouchableOpacity>
                                                       </View>

                                                       <View
                                                           style={{
                                                               flex: 1,
                                                               flexDirection: 'row',
                                                               paddingHorizontal: moderateScale(10),
                                                               alignItems: 'center',
                                                           }}>
                                                           <TouchableOpacity style={{
                                                               width: moderateScale(24),
                                                               height: moderateScale(24),
                                                               alignItems: 'center', justifyContent: 'center',
                                                               marginHorizontal: moderateScale(3),

                                                           }}
                                                                             onPress={() => {
                                                                                 this.setLike(item, index)
                                                                             }}

                                                           >
                                                               <HMIcon
                                                                   type={"Entypo"}
                                                                   // type={"FontAwesome"}
                                                                   //   type={"AntDesign"}
                                                                   // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                   // name={item.like ? "send" : "send-o"}
                                                                   //   name={item.like ? "ios-checkmark-circle" : "ios-checkmark-circle-outline"}
                                                                   name={"publish"}
                                                                   //resizeMode="stretch"
                                                                   style={[{fontSize: moderateScale(24)}, item.like ? {
                                                                       color: "#ee0003"
                                                                   } : {
                                                                       color: "#6f6f6f"
                                                                   }]}/>
                                                               {
                                                                   // this.state["isLoading" + "setLike" + index] ?
                                                                   //     <View style={{position: 'absolute'}}>
                                                                   //         <ActivityIndicator color={Colors.colorPrimary}
                                                                   //                            size={"large"}/>
                                                                   //     </View>
                                                                   //     :
                                                                   //     null
                                                               }

                                                           </TouchableOpacity>
                                                           <TouchableOpacity style={{
                                                               width: moderateScale(24),
                                                               height: moderateScale(24),
                                                               alignItems: 'center', justifyContent: 'center',
                                                               marginHorizontal: moderateScale(3)


                                                           }}
                                                                             onPress={() => {
                                                                                 NavigationService.navigateParams("ListUserChatScreen", {extraData: item})
                                                                             }}

                                                           >
                                                               <HMIcon
                                                                   //  type={"FontAwesome"}
                                                                   type={"Feather"}
                                                                   //  type={"AntDesign"}
                                                                   // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                   //   name={item.like ? "send" : "send-o"}
                                                                   name={item.like ? "send" : "send"}
                                                                   // name={item.like ? "ios-checkmark-circle" : "ios-checkmark-circle-outline"}
                                                                   //resizeMode="stretch"
                                                                   style={[{fontSize: moderateScale(24)},
                                                                       //     item.like ? {
                                                                       //     color: "#ee0003"
                                                                       // } :
                                                                       {
                                                                           color: "#6f6f6f"
                                                                       }]}/>
                                                               {
                                                                   // this.state["isLoading" + "setLike" + index] ?
                                                                   //     <View style={{position: 'absolute'}}>
                                                                   //         <ActivityIndicator color={Colors.colorPrimary}
                                                                   //                            size={"large"}/>
                                                                   //     </View>
                                                                   //     :
                                                                   //     null
                                                               }

                                                           </TouchableOpacity>
                                                           <TouchableOpacity
                                                               style={{
                                                                   width: moderateScale(24),
                                                                   height: moderateScale(24),
                                                                   alignItems: 'center', justifyContent: 'center',
                                                                   //    borderWidth: moderateScale(2),
                                                                   //  borderColor: Colors.colorDarkText,
                                                                   marginHorizontal: moderateScale(3),


                                                               }}
                                                               onPress={() => {

                                                                   this.setState({
                                                                       showModal: "selectImage",
                                                                       index: index,
                                                                       item: item,

                                                                   })
                                                               }}
                                                           >
                                                               {
                                                                   this.state["isLoadingUpload" + index] ?
                                                                       <View style={{}}>
                                                                           <ActivityIndicator color={Colors.colorPrimary}
                                                                                              size={moderateScale(34)}/>
                                                                       </View>
                                                                       :
                                                                       <HMIcon
                                                                           type={"MaterialCommunityIcons"}
                                                                           // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                           name={"image-plus"}
                                                                           //resizeMode="stretch"
                                                                           style={[{fontSize: moderateScale(30)}, {
                                                                               color: Colors.colorDarkText,
                                                                           }]}/>
                                                               }


                                                           </TouchableOpacity>


                                                           {/!*<TouchableOpacity style={{*!/}
                                                           {/!*width: moderateScale(30),*!/}
                                                           {/!*height: moderateScale(30),*!/}
                                                           {/!*alignItems: 'center', justifyContent: 'center',*!/}


                                                           {/!*}}>*!/}
                                                           {/!*<HMIcon*!/}
                                                           {/!*!// source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}*!/}
                                                           {/!*name={"ios-share-social-outline"}*!/}
                                                           {/!*!//resizeMode="stretch"*!/}
                                                           {/!*style={[{fontSize: moderateScale(30)}, {*!/}
                                                           {/!*color: Colors.colorDarkText,*!/}
                                                           {/!*}]}/>*!/}

                                                           {/!*</TouchableOpacity>*!/}


                                                           <TouchableOpacity
                                                               style={{
                                                                   width: moderateScale(24),
                                                                   height: moderateScale(24),
                                                                   alignItems: 'center', justifyContent: 'center',

                                                                   marginHorizontal: moderateScale(3),

                                                               }}
                                                               onPress={() => {
                                                                   this.setState({
                                                                       showModal: "addComment",
                                                                       comment: null,

                                                                       index: index,
                                                                       item: item,
                                                                   })

                                                               }}
                                                           >
                                                               <HMIcon
                                                                   type={"FontAwesome"}

                                                                   // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                   name={"comment-o"}
                                                                   //resizeMode="stretch"
                                                                   style={[{fontSize: moderateScale(24)}, {
                                                                       color: Colors.colorDarkText,
                                                                   }]}/>
                                                               {
                                                                   this.state["isLoading" + "AddComment" + index] ?
                                                                       <View style={{
                                                                           position: 'absolute',
                                                                           top: moderateScale(6)
                                                                       }}>
                                                                           <ActivityIndicator color={Colors.colorPrimary}
                                                                                              size={"small"}/>
                                                                       </View>
                                                                       :
                                                                       null
                                                               }
                                                           </TouchableOpacity>
                                                           <TouchableOpacity
                                                               onPress={() => {
                                                                   if (Platform.OS === "web" && !navigator.share) {
                                                                       // alert(typeExport._Url137 + "details_gallery_operation/" + item.id)
                                                                       alert(item.sharing)

                                                                   }
                                                                   else
                                                                       Tools.onShare({
                                                                           // link_url: typeExport._Url137 + "details_gallery_operation/" + item.id,
                                                                           link_url: item.sharing,
                                                                           description: "این پست را دوست شما برای شما فرستاده لطفا مشاهد نمایید"
                                                                       });


                                                               }}
                                                               style={{
                                                                   width: moderateScale(24),
                                                                   height: moderateScale(24),
                                                                   alignItems: 'center', justifyContent: 'center',
                                                                   // marginHorizontal: moderateScale(12),
                                                                   //  backgroundColor:"#72ee3b"
                                                                   marginHorizontal: moderateScale(3),

                                                               }}>
                                                               <HMIcon
                                                                   // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                   name={"ios-share-social-outline"}
                                                                   //resizeMode="stretch"
                                                                   style={[{fontSize: moderateScale(24)}, {
                                                                       color: Colors.colorDarkText,
                                                                   }]}/>

                                                           </TouchableOpacity>

                                                           <View
                                                               style={{
                                                                   flexDirection: "row",
                                                                   alignItems: 'center', justifyContent: 'center',
                                                                   marginHorizontal: moderateScale(3),


                                                               }}


                                                           >
                                                               <HMIcon
                                                                   // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                   name={"md-heart"}
                                                                   //resizeMode="stretch"
                                                                   style={[{fontSize: moderateScale(24)}, {
                                                                       color: "#ee0003"
                                                                   }]}/>
                                                               <HMTextView
                                                                   //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                   text={`${item.count_like ? item.count_like : 0} نفر پسند شده`}
                                                                   type={"bold"}
                                                                   style={{
                                                                       textAlign: "center",
                                                                       color: Colors.colorDarkText,
                                                                       fontSize: moderateScale(12),
                                                                       marginHorizontal: moderateScale(2)

                                                                   }}/>
                                                           </View>

                                                           <View style={{flex: 1}}/>
                                                           <HMTextView
                                                               //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                               text={item.createdtime}
                                                               type={"bold"}
                                                               style={{
                                                                   textAlign: "center",
                                                                   color: Colors.colorDark,
                                                                   fontSize: moderateScale(13),
                                                                   marginHorizontal: moderateScale(2)

                                                               }}/>
                                                       </View>
                                                       <View
                                                           style={{
                                                               flexDirection: "row",
                                                               flex: 1,
                                                               //  width:'100%',
                                                               //   justifyContent: "flex-end",
                                                               flexWrap: 'wrap',
                                                               marginHorizontal: moderateScale(12),
                                                               marginVertical: moderateScale(6),

                                                           }}>
                                                           <HMTextView
                                                               //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                               text={"موضوع" + " : "}
                                                               type={"bold"}
                                                               style={{
                                                                   textAlign: "center",
                                                                   color: Colors.blackLight,
                                                                   fontSize: moderateScale(14)

                                                               }}/>
                                                           <HMTextView
                                                               //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                               text={item.title}
                                                               type={"bold"}
                                                               style={{
                                                                   //  textAlign: "center",
                                                                   color: Colors.colorDark,
                                                                   fontSize: moderateScale(14)

                                                               }}
                                                               styleRoot={{
                                                                   flexDirection: 'row',
                                                                   flex: 1,
                                                                   // justifyContent: "flex-end",
                                                                   flexWrap: 'wrap',
                                                                   //    alignItems: 'center', justifyContent: 'center'
                                                               }}
                                                           />
                                                       </View>
                                                       <View
                                                           style={{
                                                               flexDirection: "row",
                                                               flex: 1,
                                                               //  width:'100%',
                                                               //   justifyContent: "flex-end",
                                                               flexWrap: 'wrap',
                                                               marginHorizontal: moderateScale(12),
                                                               marginVertical: moderateScale(6),

                                                           }}>
                                                           <HMTextView
                                                               //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                               text={"آدرس" + " : "}
                                                               type={"bold"}
                                                               style={{
                                                                   textAlign: "center",
                                                                   color: Colors.blackLight,
                                                                   fontSize: moderateScale(14)

                                                               }}/>
                                                           <HMTextView
                                                               //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                               text={item.address}
                                                               type={"bold"}
                                                               style={{
                                                                   //  textAlign: "center",
                                                                   color: Colors.colorDark,
                                                                   fontSize: moderateScale(14)

                                                               }}
                                                               styleRoot={{
                                                                   flexDirection: 'row',
                                                                   flex: 1,
                                                                   // justifyContent: "flex-end",
                                                                   flexWrap: 'wrap',
                                                                   //    alignItems: 'center', justifyContent: 'center'
                                                               }}
                                                           />
                                                       </View>
                                                       <View style={{marginBottom: moderateScale(8)}}>
                                                           {
                                                               item.lastWork ?
                                                                   item.lastWork.map((itemWork, indexWork) => {
                                                                       return <View
                                                                           key={indexWork}
                                                                           style={{
                                                                               flex: 1,
                                                                               flexDirection: 'row',

                                                                               //  width:'100%',
                                                                               //   justifyContent: "flex-end",
                                                                               flexWrap: 'wrap',
                                                                               //alignItems: 'center',
                                                                               marginHorizontal: moderateScale(12),
                                                                               marginVertical: moderateScale(5),
                                                                               borderWidth: moderateScale(.7),
                                                                               borderRadius: moderateScale(2),

                                                                               borderColor: '#ddd',
                                                                               borderBottomWidth: moderateScale(.7),
                                                                               shadowColor: '#000',
                                                                               shadowOffset: {
                                                                                   width: 0,
                                                                                   height: moderateScale(.7)
                                                                               },
                                                                               shadowOpacity: 0.6,
                                                                               shadowRadius: moderateScale(2),
                                                                               elevation: moderateScale(1),

                                                                               // borderRadius: moderateScale(8),
                                                                               margin: moderateScale(8),
                                                                               padding: moderateScale(10),
                                                                               // backgroundColor:"#F2F2F2"
                                                                           }}>
                                                                           <TouchableOpacity
                                                                               style={{
                                                                                   width: moderateScale(28),
                                                                                   height: moderateScale(28),
                                                                                   alignItems: 'center',
                                                                                   justifyContent: 'center',
                                                                               }}
                                                                               onPress={() => {
                                                                                   const formData = new FormData();
                                                                                   formData.append('lang', i18n.locale);
                                                                                   formData.append('record', item.id);
                                                                                   formData.append('recordChild', itemWork.id);
                                                                                   formData.append('_session', container.props.token);
                                                                                   formData.append('_operation', typeExport._Shahrdar);
                                                                                   // // formData.append('lang', params.lang);
                                                                                   formData.append('mode', "SetLikeComment");
                                                                                   store.dispatch(serviceActionSetDisplayComment(!itemWork.display, index, indexWork))

                                                                                   this.setData(() => {
                                                                                   }, formData, index + "SetDisplayComment" + indexWork)
                                                                                   // const some_array = [...this.state.list]
                                                                                   //
                                                                                   // some_array[index].lastWork[indexWork].display = !this.state.list[index].lastWork[indexWork].display
                                                                                   //
                                                                                   // this.setState({list: some_array}
                                                                                   //     ,
                                                                                   //     () => {

                                                                                   //     }
                                                                                   // )
                                                                               }}

                                                                           >
                                                                               <HMIcon
                                                                                   // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                                   name={itemWork.display ? "md-eye" : "eye-off"}
                                                                                   //resizeMode="stretch"
                                                                                   style={[{fontSize: moderateScale(28)},
                                                                                       {
                                                                                           color: Colors.colorSecondPrimary
                                                                                       }
                                                                                   ]}/>
                                                                               {
                                                                                   // this.state["isLoading" + index + "SetDisplayComment" + indexWork] ?
                                                                                   //     <View style={{position: 'absolute',}}>
                                                                                   //         <ActivityIndicator
                                                                                   //             color={Colors.colorPrimary}
                                                                                   //             size={"large"}/>
                                                                                   //     </View>
                                                                                   //     :
                                                                                   //     null
                                                                               }
                                                                           </TouchableOpacity>
                                                                           <TouchableOpacity style={{
                                                                               width: moderateScale(26),
                                                                               height: moderateScale(26),
                                                                               alignItems: 'center',
                                                                               justifyContent: 'center',
                                                                               marginHorizontal: moderateScale(8)


                                                                           }}
                                                                                             onPress={() => {
                                                                                                 valueComment = itemWork.comment;
                                                                                                 this.setState({
                                                                                                         showModal: true,
                                                                                                         comment: itemWork.comment,

                                                                                                         index: index,
                                                                                                         indexWork: indexWork,
                                                                                                         item: item,
                                                                                                         itemWork: itemWork,
                                                                                                     },

                                                                                                     () => {
                                                                                                         if (this.refInputTextComment)
                                                                                                             this.refInputTextComment.setNativeProps({text: itemWork.comment});

                                                                                                     }
                                                                                                 )

                                                                                             }}
                                                                           >
                                                                               <HMIcon
                                                                                   // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                                   name={"pencil-sharp"}
                                                                                   //resizeMode="stretch"
                                                                                   style={[{fontSize: moderateScale(24)}, {
                                                                                       color: "#6f6f6f"
                                                                                   }]}/>
                                                                               {
                                                                                   // this.state["isLoading" + index + "SetComment" + indexWork] ?
                                                                                   //     <View style={{position: 'absolute',}}>
                                                                                   //         <ActivityIndicator
                                                                                   //             color={Colors.colorPrimary}
                                                                                   //             size={'large'}/>
                                                                                   //     </View>
                                                                                   //     :
                                                                                   //     null
                                                                               }
                                                                           </TouchableOpacity>
                                                                           <View
                                                                               style={{
                                                                                   flexDirection: Platform.OS === "web" && this.state.viewportWidth > 800 ? "row" : "column",
                                                                                   flex: 1,
                                                                                   //  width:'100%',
                                                                                   //   justifyContent: "flex-end",
                                                                                   flexWrap: 'wrap',
                                                                                   marginHorizontal: moderateScale(12),
                                                                                   marginVertical: moderateScale(6),

                                                                               }}>
                                                                               <HMTextView
                                                                                   //                                                    flexDirection: Platform.OS==="web"&& this.state.viewportWidth>800?"row":"column",
                                                                                   //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                   text={itemWork.title + " : "}
                                                                                   type={"bold"}
                                                                                   style={{
                                                                                       textAlign: "center",
                                                                                       color: Colors.blackLight,
                                                                                       fontSize: moderateScale(14)

                                                                                   }}/>
                                                                               <HMTextView
                                                                                   //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                   text={itemWork.comment}
                                                                                   type={"bold"}
                                                                                   style={{
                                                                                       //  textAlign: "center",
                                                                                       color: Colors.colorDark,
                                                                                       fontSize: moderateScale(14)

                                                                                   }}

                                                                                   styleRoot={{
                                                                                       //  flexDirection: "row",
                                                                                       flex: 1,
                                                                                       //  width:'100%',
                                                                                       //   justifyContent: "flex-end",
                                                                                       flexWrap: 'wrap',

                                                                                   }}
                                                                               />
                                                                           </View>


                                                                       </View>
                                                                   })
                                                                   :
                                                                   null
                                                           }
                                                           {/!*   <FlatList
                                                       style={{height: moderateScale(30)}}
                                                       data={item.lastWork}
                                                       //  data={this.props.ListFilter ? this.props.ListFilter : []}
                                                       // data={[
                                                       //     {
                                                       //
                                                       //         type: '1',
                                                       //         name: 'وضعیت پیام',
                                                       //
                                                       //     },
                                                       //     {
                                                       //
                                                       //         type: '2',
                                                       //         name: 'واحد اجرایی',
                                                       //     },
                                                       //
                                                       //     // {
                                                       //     //
                                                       //     //     type: '3',
                                                       //     //     name: 'تاریخ',
                                                       //     // },
                                                       //
                                                       // ]}
                                                       //   numColumns={3}
                                                       renderItem={({item: itemWork, index: indexWork}) => {

                                                           return <View
                                                               style={{
                                                               flex: 1,
                                                               flexDirection: 'row',
                                                               backgroundColor: Colors.white,
                                                               borderRadius: moderateScale(8),
                                                               margin: moderateScale(8),
                                                               padding: moderateScale(10)
                                                           }}>
                                                               <TouchableOpacity style={{
                                                                   width: moderateScale(28),
                                                                   height: moderateScale(28),
                                                                   alignItems: 'center', justifyContent: 'center',


                                                               }}>
                                                                   <HMIcon
                                                                       // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                       name={"md-eye"}
                                                                       //resizeMode="stretch"
                                                                       style={[{fontSize: moderateScale(28)}, itemWork.display ?
                                                                           {
                                                                               color: Colors.colorSecondPrimary
                                                                           }
                                                                           :
                                                                           {
                                                                               color: "#6f6f6f"
                                                                           }]}/>

                                                               </TouchableOpacity>
                                                               <TouchableOpacity style={{
                                                                   width: moderateScale(26),
                                                                   height: moderateScale(26),
                                                                   alignItems: 'center', justifyContent: 'center',
                                                                   marginHorizontal: moderateScale(8)


                                                               }}>
                                                                   <HMIcon
                                                                       // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                                       name={"pencil-sharp"}
                                                                       //resizeMode="stretch"
                                                                       style={[{fontSize: moderateScale(24)}, {
                                                                           color: "#6f6f6f"
                                                                       }]}/>

                                                               </TouchableOpacity>

                                                               <HMTextView
                                                                   //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                   text={itemWork.title + " : "}
                                                                   type={"bold"}
                                                                   style={{
                                                                       textAlign: "center",
                                                                       color: Colors.blackLight,
                                                                       fontSize: moderateScale(14)

                                                                   }}/>
                                                               <HMTextView
                                                                   //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                   text={itemWork.comment}
                                                                   type={"bold"}
                                                                   style={{
                                                                       textAlign: "center",
                                                                       color: Colors.colorDark,
                                                                       fontSize: moderateScale(14)

                                                                   }}/>
                                                           </View>
                                                       }}
                                                       showsHorizontalScrollIndicator={false}
                                                       keyExtractor={(item, index) => index.toString()}
                                                       // inverted={Platform.OS === 'android' && i18n.locale == 'fa'}

                                                       scrollEnabled={false}



                                                   />*!/}

                                                       </View>

                                                   </View>

                                               </View>
                                           }}
                                           renderFooter={this.renderFooter.bind(this)}
                                           columnCount={this.state.columnCount}
                                       />*/
                                ) : null}
                            </View>
                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData(this.props.page)}/> : null
                            }
                            {
                                this.state.isLoading || (this.props.results && this.props.results.length === 0) ?
                                    <DialogLoadingCustomize
                                    />
                                    :
                                    null
                            }
                            <HMModalSearch
                                visibleModal={this.state.visibleModal === 'Modal'}
                                hiddenModal={() => this.hiddenModal()}
                                textInput={this.state["text" + this.state.indexFilter]}
                                SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                //textInput={this.state.mobile}
                                dataSource={this.state["dataSource" + this.state.indexFilter]}
                                // onChange={() => this.onChangeCondition(index, item)}
                                onChangeItem={this.onChange}
                            />

                            <HMModal
                                // style={{backgroundColor: Colors.transparent}}
                                // position={"center"}
                                // ref={"modal"}
                                // backdropPressToClose={true}
                                // coverScreen={true}
                                // swipeToClose={true}
                                // backButtonClose={true}
                                // isOpen={this.state.showModal}
                                // onClosed={() => this.setState({showModal: false})}

                                isVisible={this.state.showModal}
                                //visible={this.state.visibleModal}
                                backdropColor={Colors.gray}
                                backdropOpacity={0.8}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={() =>
                                    this.hiddenModal()
                                }
                                onBackButtonPress={() =>
                                    this.hiddenModal()
                                }

                                animationType="slide"
                                // transparent={true}
                            >

                                {

                                    this.state.showModal === "selectImage" ?
                                        <TouchableOpacity
                                            activeOpacity={1}
                                            style={{
                                                width: "100%",
                                                backgroundColor: Colors.white,
                                                padding: moderateScale(16),
                                                position: 'absolute',
                                                bottom: 0,
                                            }}>
                                            <View
                                                style={{
                                                    width: '100%',
                                                    flexDirection: 'row',
                                                    marginBottom: moderateScale(6)
                                                }}>
                                                {
                                                    Platform.OS !== "web" ?
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                if (Platform.OS !== "web")
                                                                    ImagePicker.openCamera(typeExport.optional).then(image => {
                                                                        this.uploadFile(image);
                                                                    });

                                                            }}
                                                            style={{
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                backgroundColor: '#A131C9',
                                                                width: moderateScale(48),
                                                                height: moderateScale(48),
                                                                borderRadius: moderateScale(24),
                                                                margin: moderateScale(5),
                                                                padding: moderateScale(8),
                                                                //  borderRadius: moderateScale(4),
                                                            }}>


                                                            <HMIcon type={"FontAwesome"} name={"camera"} style={{
                                                                width: moderateScale(22),
                                                                height: moderateScale(22),
                                                                //  borderRadius:moderateScale(20),
                                                                textAlign: 'center',
                                                                //alignSelf: 'flex-end',
                                                                color: Colors.white,
                                                                //width: moderateScale(32),
                                                                // height: moderateScale(32),
                                                                fontSize: moderateScale(21)
                                                            }}/>

                                                        </TouchableOpacity>
                                                        :
                                                        null
                                                }


                                                <View
                                                    style={{
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: moderateScale(48),
                                                        height: moderateScale(48),

                                                        //  borderRadius: moderateScale(4),
                                                    }}
                                                >
                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            if (Platform.OS !== "web")
                                                                ImagePicker.openPicker({
                                                                    width: 1000,
                                                                    height: 1000,
                                                                    // crop: true,

                                                                    cropping: true
                                                                }).then(image => {
                                                                    // this.state.listImage.push(image)
                                                                    this.uploadFile(image);


                                                                });


                                                        }}
                                                        style={{
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            backgroundColor: '#3AABDC',
                                                            padding: moderateScale(8),
                                                            margin: moderateScale(5),
                                                            width: moderateScale(48),
                                                            height: moderateScale(48),
                                                            borderRadius: moderateScale(24),
                                                        }}>

                                                        <HMIcon type={"FontAwesome"} name={"image"} style={{
                                                            width: moderateScale(22),
                                                            height: moderateScale(22),
                                                            //  borderRadius:moderateScale(20),
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.white,
                                                            //width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(21)
                                                        }}/>


                                                    </TouchableOpacity>
                                                    {
                                                        Platform.OS !== "web" ?
                                                            null
                                                            :
                                                            <label
                                                                onChange={this.fileSelect}

                                                                // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    bottom: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    opacity: .009
                                                                }}>
                                                                <input type="file" accept="image/*"/>

                                                            </label>
                                                    }
                                                </View>
                                            </View>
                                        </TouchableOpacity>
                                        :
                                        (
                                            this.state.showModal ?
                                                <TouchableOpacity
                                                    activeOpacity={1}
                                                    style={{
                                                        width: "96%",
                                                        backgroundColor: Colors.white,
                                                        padding: moderateScale(16)
                                                    }}>


                                                    <View style={{width: '100%'}}>
                                                        <HMTextView
                                                            type={"bold"}
                                                            noFont={false}
                                                            text={this.state.showModal === "addComment" ? "متن مورد نظر را وارد نمایید" : "متن مورد نظر را ویرایش نمایید"}
                                                            numberOfLines={1}
                                                            style={{
                                                                fontSize: moderateScale(15),
                                                                textAlign: 'right',
                                                                color: Colors.blackLight
                                                            }}/>
                                                        <View
                                                            style={{

                                                                paddingVertical: moderateScale(10),
                                                                marginHorizontal: moderateScale(6)
                                                            }}
                                                        >
                                                            <HMTextInput
                                                                onRef={(ref) => {
                                                                    this.refInputTextComment = ref?.textInput
                                                                }}


                                                                // value={valueComment}
                                                                number
                                                                //  onEndEditing={text => {
                                                                //      //this.setState({comment: text})
                                                                //  }}
                                                                onChangeText={text => {
                                                                    valueComment = text;
                                                                    //this.setState({comment: text})
                                                                }}

                                                                _height={moderateScale(100)}
                                                                //   keyboardType="numeric"
                                                                //  placeholder={i18n.t('constant.PlaceholderDesc')}
                                                                style={{
                                                                    // height:moderateScale(100),
                                                                    fontSize: moderateScale(14)
                                                                }} underlineColorAndroid="transparent"
                                                                styleInput={{height: moderateScale(80)}}

                                                                // textCenter={'center'}
                                                                //   onBlur={() => {}}}
                                                                SpeechToText

                                                            />


                                                        </View>
                                                        <TouchableOpacity
                                                            style={{
                                                                backgroundColor: Colors.colorPrimary,
                                                                width: moderateScale(100),
                                                                height: moderateScale(40),
                                                                alignSelf: 'center',
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                marginTop: moderateScale(8),
                                                                borderRadius: moderateScale(6)
                                                                // borderRadius:moderateScale(2)
                                                            }}
                                                            onPress={() => {

                                                                if (valueComment && valueComment.length > 0) {
                                                                    this.setState({comment: valueComment})
                                                                    let {index, indexWork, item, itemWork, showModal} = this.state
                                                                    // this.getData()
                                                                    this.setState({showModal: false, typeModal: ""})

                                                                    const formData = new FormData();
                                                                    formData.append('lang', i18n.locale);
                                                                    //  formData.append('record', item.id);
                                                                    let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) && false ? item.tracking_code : item.id;
                                                                    formData.append('record', id);
                                                                    if (itemWork)
                                                                        formData.append('recordChild', itemWork.id);

                                                                    formData.append('_session', container.props.token);
                                                                    formData.append('_operation', typeExport._Shahrdar);
                                                                    // // formData.append('lang', params.lang);
                                                                    formData.append('mode', showModal === "addComment" ? "AddAlbumComment" : "EditAlbumComment");
                                                                    //  formData.append('comment', this.state.comment);
                                                                    formData.append('comment', valueComment);


                                                                    if (showModal !== "addComment") {
                                                                        // store.dispatch(serviceActionSetComment(this.state.comment, index, indexWork))
                                                                        store.dispatch(serviceActionSetComment(valueComment, index, indexWork))
                                                                    }
                                                                    this.setData((res) => {
                                                                        if (showModal === "addComment") {
                                                                            store.dispatch(serviceActionAddComment(res, index))

                                                                        }
                                                                        // else
                                                                        //     store.dispatch(serviceActionSetComment(this.state.comment, index, indexWork))

                                                                        this.setState({showModal: false}
                                                                            ,
                                                                            () => {

                                                                            }
                                                                        )
                                                                    }, formData, showModal === "addComment" ? "AddComment" + index : index + "SetComment" + indexWork)

                                                                    // const some_array = [...this.state.list]
                                                                    //
                                                                    // some_array[index].lastWork[indexWork].comment = this.state.comment
                                                                    //
                                                                    // this.setState({list: some_array, showModal: false}
                                                                    //     ,
                                                                    //     () => {

                                                                    //     }
                                                                    // )
                                                                }
                                                                else {
                                                                    HMAlert(
                                                                        i18n.t('constant.message'),
                                                                        "لطفا متن خود را وارد نمایید",
                                                                        [
                                                                            {
                                                                                text: i18n.t('constant.ok'),
                                                                                onPress: () => {

                                                                                }


                                                                            },

                                                                        ],
                                                                        {cancelable: true}
                                                                    )
                                                                }

                                                            }}
                                                        >
                                                            <View style={{
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}>
                                                                <HMTextView type={"bold"}
                                                                    //   text={i18n.t('constant.signIn')}
                                                                            text={this.state.showModal === "addComment" ? i18n.t('constant.Registration') : i18n.t('constant.Edit')}
                                                                    //  text={"ثبت"}

                                                                            style={{
                                                                                color: "white",
                                                                                fontSize: moderateScale(13),
                                                                                //marginEnd: moderateScale(10)
                                                                            }}/>

                                                            </View>
                                                        </TouchableOpacity>
                                                    </View>

                                                    <TouchableOpacity
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            right: 0,
                                                            padding: moderateScale(8)
                                                        }}
                                                        onPress={() => {
                                                            this.hiddenModal()
                                                        }}
                                                    >
                                                        <HMIcon name={"ios-close"} style={{
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(28)
                                                        }}/>
                                                    </TouchableOpacity>
                                                </TouchableOpacity>
                                                :
                                                null
                                        )

                                }

                            </HMModal>
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderItem = ({item, index}) => {
        return <AdapterListOperatorApply item={item} item_parent={this.props.route.params.item}
                                         index={index} hiddenModal={this.hiddenModal}/>;
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashGetAllData.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            {
                <View
                    style={[{
                        //marginVertical: moderateScale(15),
                        height: moderateScale(36),
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row',
                    }]}>
                    {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                    {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                    {
                        checkIndex ?

                            <View style={{flexDirection: 'row'}}>


                                <TouchableOpacity
                                    onPress={() => {
                                        //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                        let arr = container.state.arraySelected;

                                        if (idx !== -1) {
                                            arr.splice(idx, 1)

                                            container.setState({
                                                    arraySelected: arr,
                                                    [`selectFilter${index}`]: {
                                                        value: item.name,
                                                        id: item.id,
                                                        type: item.type
                                                    },
                                                    visibleModal: '',
                                                },

                                                () => {
                                                    container.getData(1)
                                                }
                                            )
                                        }
                                        // container.setState({
                                        //         [`selectFilter${index}`]: {
                                        //             value: item.name,
                                        //             id: item.id,
                                        //             type:item.type
                                        //         },
                                        //         visibleModal: '',
                                        //     },
                                        //     () => {
                                        //         let arr = this.state.arraySelected;
                                        //         this.setState({
                                        //                 arraySelected: arr
                                        //             },
                                        //             () => {
                                        //                 container.getData(1)
                                        //             }
                                        //         )
                                        //
                                        //     }
                                        // )

                                    }}
                                    style={{
                                        alignSelf: 'center',
                                        //  marginHorizontal:moderateScale(6)
                                    }}>
                                    <HMIcon name={"md-close"} style={{
                                        fontSize: moderateScale(24),
                                        color: '#f2f2f2'
                                    }}/>

                                </TouchableOpacity>
                            </View>
                            :
                            null


                    }
                    {
                        checkIndex ?
                            <View style={{width: moderateScale(6),}}/>

                            :
                            null
                    }
                    <TouchableOpacity
                        onPress={() => {

                            this.setState({
                                    indexFilter: index,
                                    typeFilter: item.type,
                                    ["dataSource" + index]: item.list
                                },
                                () => {
                                    //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                    this.onShow('Modal')

                                })
                        }
                        }

                        style={{alignItems: 'center', flexDirection: 'row'}}
                    >

                        <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                    style={{
                                        color: checkIndex ? Colors.white : Colors.gray,
                                        //marginHorizontal: moderateScale(6),
                                        fontSize: moderateScale(13),
                                        textAlign: 'center',

                                    }}/>
                        <HMIcon name={"ios-arrow-down"} style={{
                            fontSize: moderateScale(13),
                            color: checkIndex ? '#f2f2f2' : Colors.gray,
                            marginHorizontal: moderateScale(2),
                            marginTop: moderateScale(3)
                        }}/>
                    </TouchableOpacity>


                </View>

            }
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashGetAllData.Connection) {
            this.getData(1)
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlGalleryServiceOperationScreen, `?type=${this.props.typee}&city=`, TypeGetGalleryServiceOperationScreen, 'POST', 1)
    }

    renderFooter() {
        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {

        if (this.state.loadData && (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashGetAllData.Connection)) {
            // this.props.callService(urlGalleryServiceOperationScreen, `?type=${this.props.typee}&Condition=`, TypeGetGalleryServiceOperationScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {

        container.setState({visibleModal: '', showModal: false, typeModal: ""}, () => {
            valueComment = null
        })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }

    fileSelect = async event => {
        // NavigationService.BackTo(2)

        let image = await Tools.resizeFile(event.target.files[0]);


        // this.uploadFile(image, true)

        //this.state.arrImage.push(image)

        this.setState({
            //ShowImage:true
            showModal: false,
            //pathImage: image
        })


        // let {index, indexWork} = this.state;
        container.uploadFile(image, true);


        // // this.getData()
        // const some_array = [...this.state.list]
        //
        // some_array[index].slider.push({
        //     id: 4,
        //     image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/1200px-Image_created_with_a_mobile_phone.png",
        //     display: true
        // })
        //
        // this.setState({list: some_array, showModal: false}
        //     ,
        //     () => {

        //     }
        // )
    }

    setLike(item, index) {

        const formData = new FormData();
        formData.append('lang', i18n.locale);
        let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) && false ? item.tracking_code : item.id;
        formData.append('record', id);


        formData.append('_session', container.props.token);
        formData.append('_operation', typeExport._Shahrdar);
        // // formData.append('lang', params.lang);
        formData.append('mode', "SetLikeTicket");
        store.dispatch(serviceActionSetLike(!item.like, index))

        this.setData(() => {
        }, formData, "setLike" + index)
        // const some_array = [...this.state.list]
        //
        // some_array[index].like = !this.state.list[index].like
        //
        // this.setState({list: some_array}
        //     ,
        //     () => {
        //     }
        // )
    }


    setData(func, formData, type) {
        formData.append('platform', Platform.OS);

        let nameLoading = "isLoading" + type;
        let nameNoInternetDialog = "NoInternetDialog" + type;

        container.setState({
                //ShowImage:true
                [nameLoading]: true,
                [nameNoInternetDialog]: false,

            },

            () => {
            }
        )


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    Toast.show({
                        // type: 'success | error | info',
                        type: 'info',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: data.error && data.error.message ? data.error.message : data.message,
                        visibilityTime: 4000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })
                    // HMAlert(
                    //     i18n.t('constant.message'),
                    //     data.error &&  data.error.message?data.error.message:data.message,
                    //     [
                    //         {
                    //             text: i18n.t('constant.ok'), onPress: () => {
                    //
                    //             }
                    //
                    //
                    //         },
                    //
                    //     ],
                    //     {cancelable: true}
                    // )
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    [nameLoading]: false,
                    [nameNoInternetDialog]: !data.status,

                })
            }).catch((e) => {
            HMAlert(
                i18n.t('constant.message'),
                "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                [
                    {
                        text: i18n.t('constant.ok'), onPress: () => {

                        }


                    },

                ],
                {cancelable: true}
            )
            container.setState({
                //ShowImage:true
                [nameLoading]: false,
                [nameNoInternetDialog]: true,

            })
            console.log('error', e)
        })
    }

    uploadFile(image, web) {
        let {item, index, indexWork} = this.state;

        let nameIsLoadingUpload = "isLoadingUpload" + index;
        let nameErrorUpload = "errorUpload" + index;

        this.setState({
            //ShowImage:true
            [nameIsLoadingUpload]: true,
            [nameErrorUpload]: false,
            visibleModal: '',
            pathImage: image.path
        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "AddAlbumFile");
        formData.append('_session', this.props.token);
        formData.append('_session', this.props.token);
        formData.append('platform', Platform.OS);

        //  formData.append('record', item.id);
        let id = ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) && false ? item.tracking_code : item.id;
        formData.append('record', id);
        // let DateTime = new Date().getTime()
        // let nameImage = DateTime + '.jpg';
        if (web) {
            formData.append('file', image, image.name + ".JPG");
            /*   formData.append('image' + ii, {
                   uri: image,
                   name: image.name,
                   type: 'image/jpeg'
               });*/
        } else {
            let arr = []
            for (let i = 0; i < 1; i++) {
                let ii = i + 1;
                let DateTime = new Date().getTime()
                let nameImage = DateTime + "_" + ii + '.jpg';
                formData.append('image' + ii, {
                    uri: image.path,
                    name: nameImage,
                    type: 'image/jpeg'
                });

            }
        }

        //   if (image && image !== null) formData.append('image[]', arr);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };

        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

            // onUploadProgress:progressEvent=>{
            // }
            // onUploadProgress: function (progressEvent) {
            // },
        })
        //   axios.post(typeExport._baseUrlSatia + "user/uploadFiles", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    store.dispatch(serviceActionAddFile(data.result, index))


                    this.setState({
                        //ShowImage:true
                        listImage: data.result,
                        //TypeDocumentsList:[],
                        [nameIsLoadingUpload]: false,
                        [nameErrorUpload]: !data.status,
                        visibleModal: '',
                        pathImage: image.path
                    })
                }
                else {
                    this.ShowError(image, response)
                }

            }).catch((e) => {
            this.ShowError(image)


            console.log('error', e)
        })
    }

    ShowError(image, response) {
        let {item, index, indexWork} = this.state;

        let nameIsLoadingUpload = "isLoadingUpload" + index;
        let nameErrorUpload = "errorUpload" + index;
        this.setState({
                //ShowImage:true
                // listImage:  data.status ? data.result : this.state.listImage,
                //TypeDocumentsList:[],
                [nameIsLoadingUpload]: false,
                [nameErrorUpload]: true,
                visibleModal: '',
                pathImage: image ? image.path : null
            },
            () => {
                HMAlert(
                    i18n.t('constant.message'),
                    response ? response.data.message : i18n.t('constant.retry'),
                    [
                        {
                            text: i18n.t('constant.ok'), onPress: () => {

                            }


                        },

                    ],
                    {cancelable: true}
                )
            })
    }
}
const delayTime = 300;
let container2 = null;

class DynamicContentSlide extends React.Component {
    constructor(props) {
        super(props);
        container2 = this;
    }

    state = {
        isButtonDisplayed: true,
        firstPress: true,
        lastTime: true,
        backClickCount: 0


    };

    render() {
        const {itemSwiper, indexSwiper, index, onPress, onPressLike, loadingDisplayImage, _key, itemParent} = this.props;
        const {isButtonDisplayed, firstPress, lastTime} = this.state;
        let timer = false;
        let ViewCustom = onPress ? TouchableOpacity : View;

        return (
            <TouchableOpacity
                //  key={indexSwiper + "_" + index}
                activeOpacity={1}
                onPress={onPressLike}
                style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",

                    // marginHorizontal: moderateScale(4),
                    //  marginBottom:moderateScale(20),
                    //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                    backgroundColor: '#000',
                    //    borderTopRightRadius:moderateScale(8),
                    // borderTopEndRadius: moderateScale(12),
                    // borderTopStartRadius: moderateScale(8),

                    borderRadius: moderateScale(10),
                    overflow: "hidden"
                }}
            >
                <HMImageView
                    resizeMode={'contain'}
                    uriComplete={itemSwiper.file}

                    // uriComplete={"https://137yar.ahvaz.ir/uploads/watermarked_00022045-05102021175016749.jpg"}
                    //    uriComplete={"https://137yar.ahvaz.ir/img/complaint.png"}

                    _backgroundColorLoading={Colors.black}
                    styleImage={{
                        //  resizeMode: 'cover',
                        width: "100%",
                        height: "100%",
                        //  backgroundColor: "#ee7e0c",
                        //  borderTopRightRadius:moderateScale(8),
                        // borderTopEndRadius: moderateScale(12),
                        // borderTopStartRadius: moderateScale(8),
                        borderRadius: moderateScale(10),

                    }}
                    //  onLoad={this._onLoad}
                    //  onError={(e)=>{console.log(e)}} // prevent infinite-loop bug
                />
                {
                    itemSwiper.label ?
                        <TouchableOpacity
                            style={{
                                position: 'absolute',
                                flexDirection: 'row',
                                //width:moderateScale(100),
                                //maxWidth:moderateScale(120),
                                top: moderateScale(10),
                                left: moderateScale(10),
                                // width: moderateScale(100),
                                height: moderateScale(34),

                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: moderateScale(8),
                                backgroundColor: Colors.white,
                                borderWidth: moderateScale(1),
                                borderColor: Colors.colorPrimary,
                                paddingHorizontal: moderateScale(6),
                                paddingVertical: moderateScale(4),
                                //    padding:moderateScale(14)


                            }}
                            onPress={onPress}
                        >
                            <HMTextView
                                type={"bold"}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // width: '100%',
                                        textAlign: "center",
                                        color: Colors.blackLight,
                                        fontSize: moderateScale(12),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                styleRoot={{
                                    maxWidth: moderateScale(120),

                                }}
                                numberOfLines={1}
                                text={itemSwiper.label}
                                //text={"احمد خلیل احمد   یب یبلیبلل بلسیب سیا ستایببتسی ستیابب" }
                            />

                        </TouchableOpacity>
                        :
                        null
                }

                {
                    itemParent.type == 10 ?
                        null
                        :
                        <TouchableOpacity
                            style={{
                                position: 'absolute',
                                bottom: moderateScale(10),
                                left: moderateScale(10),
                                width: moderateScale(50),
                                height: moderateScale(34),
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: moderateScale(8),
                                backgroundColor: Colors.white,
                                borderWidth: moderateScale(1),
                                borderColor: Colors.colorPrimary,
                                //    padding:moderateScale(14)


                            }}
                            onPress={onPress}
                        >
                            {/*<HMTextView
                        type={"bold"}

                        style={[
                            {
                                // position: 'absolute',
                                //  bottom: 0,
                                // height: moderateScale(44),
                                // width: '100%',
                                textAlign: "center",
                                color: Colors.blackLight,
                                fontSize: moderateScale(13),
                                //  padding: moderateScale(1),

                                // backgroundColor: 'rgba(0,0,0,0.25)',
                            }]}
                        numberOfLines={2}
                        text={itemSwiper.display + ""}
                    />*/}
                            <HMIcon
                                // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                name={itemSwiper.display ? "md-eye" : "eye-off"}
                                //resizeMode="stretch"
                                style={[{fontSize: moderateScale(32)},
                                    {
                                        color: Colors.colorSecondPrimary
                                    }
                                ]}/>
                            {/*    {
                        loadingDisplayImage ?
                            <View style={{position: 'absolute',}}>
                                <ActivityIndicator
                                    color={Colors.colorPrimary}
                                    size={"large"}/>
                            </View>
                            :
                            null
                    }*/}
                        </TouchableOpacity>
                }


                <View
                    style={{
                        position: 'absolute',
                        top: moderateScale(10),
                        right: moderateScale(10),
                        width: moderateScale(34),
                        height: moderateScale(34),
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: moderateScale(17),
                        backgroundColor: Colors.blackLight,
                        borderWidth: moderateScale(1),
                        borderColor: Colors.white,
                        //    padding:moderateScale(14)


                    }}

                >

                    <HMIcon
                        type={itemSwiper.source === "ios" || itemSwiper.source === null || itemSwiper.source === "" ? "MaterialCommunityIcons" : null}
                        // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                        name={itemSwiper.source && itemSwiper.source !== "" ? (itemSwiper.source === "android" ? "ios-logo-android" : (itemSwiper.source === "ios" ? "apple" : "ios-logo-pwa")) : "web"}
                        //resizeMode="stretch"
                        style={[{fontSize: moderateScale(22)},
                            {
                                color: Colors.white
                            }
                        ]}/>

                </View>
                {
                    itemSwiper.title ?

                        <View
                            style={[
                                {
                                    position: 'absolute',
                                    bottom: 0,
                                    height: moderateScale(50),
                                    // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                    width: '100%',
                                    color: Colors.white,
                                    padding: moderateScale(3),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }]}
                        >
                            <HMTextView
                                type={"bold"}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // height: moderateScale(44),
                                        // width: '100%',
                                        textAlign: "center",
                                        color: Colors.white,
                                        fontSize: moderateScale(13),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                numberOfLines={2}
                                text={itemSwiper.title}
                            />
                        </View>
                        : null
                }
            </TouchableOpacity>
        );
    }


}
